import React, { Fragment, useState, useReducer } from "react";
import {
  Radio,
  Checkbox,
  Navbar,
  Nav,
  NavItem,
  MenuItem,
  NavDropdown,
  Modal,
  Button,
  Form,
  Dropdown,
  Row,
  Col,
  FormGroup,
  FormControl,
  ControlLabel
} from "react-bootstrap";
import { FieldGroup } from "./bootstrap/Forms.FieldGroup";
import { formDataToJSON } from "../adukku_utils/array";
import logo from "images/Composz-logo-white-trans.png";
import composzLogoBlack from "images/Composz-logo-black-trans.png";
import profile from "images/blankProfile.png";
import SubscriptionPayment from "./UserSubscription/SubscriptionPayment";
import RPSubscriptionPayment from "./UserSubscription/RPSubscriptionPayment";
import { formatCurrency } from "../adukku_utils/formatCurrency";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import CartState from "../context/cart/CartState";
import CartContext from "../context/cart/CartContext";
import { useContext } from "react";
import { Container } from "react-bootstrap/lib/Tab";
import { ENDPOINTS } from "../constants/endpoints";
import { SPLoader } from "./Spinner.js";
//import FileManager from "./UserStorage/UserStorage.js";
import PaymentModal from "./UserStorage/PaymentModal";
import RPPaymentModal from "./UserStorage/RPPaymentModal";

function ProductMynavbar(
  user_id,
  user_name,
  user_email,
  has_view_products,
  subscription_id,
  subscription_status,
  sub_count,
  sub_type,
  additionalUsers,
  sub_avail_space,
  part_of
) {
  const sub_id = parseInt(subscription_id.split("-")[1]);
  const sub_role = subscription_id.split("-")[0];

  window.audioFlg = sub_type != "AUDIO" ? false : true;
  window.subUserFlg = sub_id != 0 ? true : false;
  window.sub_id = sub_id;
  window.subscription_status = subscription_status;
  window.sub_avail_space = sub_avail_space;

  const [SubID, setSubID] = useState(sub_id);
  const [SubType, setSubType] = useState(sub_type);

  const countryCode = getCookie("countryCode");

  const convenienceCharges = 0.05;
  const gst = 0.18;
  const price =
    countryCode !== "IN"
      ? sub_type !== "AUDIO"
        ? 1.0
        : 2.0
      : sub_type !== "AUDIO"
      ? 50.0
      : 100.0;

  const [SubPrice, setSubPrice] = useState(price);

  const [mobile, setMobile] = useState(false);
  const [isFileManagerOpen, setisFileManagerOpen] = useState(false);
  const [isEditProductClicked, setisEditProductClicked] = useState(false);
  const [purchaseHistory, setpurchaseHistory] = useState([]);
  const [subFolders, setsubFolders] = useState([]);
  const [subUsers, setsubUsers] = useState([]);
  const [currentOrder, setcurrentOrder] = useState(null);
  const [Gigabyte, setGigabyte] = useState(0);
  const [agreeSub, setagreeSub] = useState(false);
  const [AgreedSub, setAgreedSub] = useState(false);
  const [formSubData, setFormSubData] = useState({});
  const [OccupiedSpace, setOccupiedSpace] = useState(0.0);
  const [TotalSpace, setTotalSpace] = useState(0.0);

  const [, forceUpdate] = useReducer((x) => x + 1, 0);

  function setCookie(cname, cvalue) {
    document.cookie = cname + "=" + cvalue + ";";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  // Extract itemscount from CartContext
  const { cartItems } = useContext(CartContext);

  const [show3, setShow3] = useState(false);
  const showDropdown3 = (e) => {
    setShow3(true);
  };
  const hideDropdown3 = (e) => {
    setShow3(false);
  };

  const [show2, setShow2] = useState(false);
  const showDropdown2 = (e) => {
    setShow2(true);
  };
  const hideDropdown2 = (e) => {
    setShow2(false);
  };

  const [show1, setShow1] = useState(false);
  const showDropdown1 = (e) => {
    setShow1(true);
    setShow(false);
  };
  const hideDropdown1 = (e) => {
    setShow1(false);
  };

  const [show, setShow] = useState(false);
  const showDropdown = (e) => {
    setShow(true);
  };
  const hideDropdown = (e) => {
    setShow(false);
  };
  const toggleShow = (e) => {
    setShow(!show);
    setShow1(false);
    setShow2(false);
    setShow3(false);
  };
  const toggleShow1 = (e) => {
    setShow1(!show1);
    setShow(false);
    setShow2(false);
    setShow3(false);
  };
  const toggleShow2 = (e) => {
    setShow2(!show2);
    setShow(false);
    setShow1(false);
    setShow3(false);
  };
  const toggleShow3 = (e) => {
    setShow3(!show3);
    setShow(false);
    setShow1(false);
    setShow2(false);
  };

  const handleToggle = (e) => {
    // do nothing
  };

  const [subCount, setsubCount] = useState(sub_count);
  const [subCreate, setsubCreate] = useState(false);
  const [subEdit, setsubEdit] = useState(false);
  const [subRenew, setsubRenew] = useState(false);
  const [payingSub, setpayingSub] = useState(false);
  const [paymentModal, setpaymentModal] = useState(false);
  const [paymentRenewal, setpaymentRenewal] = useState(false);
  const [renewSpace, setrenewSpace] = useState(false);
  const [spaceModal, setspaceModal] = useState(false);
  const [usersModal, setusersModal] = useState(false);
  const [subUserEmail, setsubUserEmail] = useState("");

  const purchaseSubscription = (e) => {
    if (part_of != "SCHOOL") {
      alert(
        "You should have been registered as 'SCHOOL' to purchase a 'Subscription'.\nIf you still want to purchase a Subscription as non-school user\nWrite an email to composz-team@composz.com\nThanks,\n--team Composz."
      );
    } else setsubCreate(true);
  };

  const today = new Date();

  const initialvalues = {
    sub_type: "NOAUDIO",
    sub_count: 0,
    avail_space: 0.0,
    total_space: 0.0,
    reclaimable_space: 0.0,
    sub_start_date: null,
    sub_end_date: null,
    status: "CREATE",
    edu_inst_name: null,
    addr_line1: null,
    addr_line2: null,
    addr_line3: null,
    city: null,
    state: null,
    zip: null,
    country_code: null,
    edu_inst_ph: null,
    sub_user_name: null,
    sub_user_title: null,
    sub_user_ph: null,
    renewalCount: 0,
    renewalUserCount: 0,
    renewalSpace: 0
  };

  const initFields = {
    no_of_gb: 0,
    storage_unit: "GIGA_BYTE",
    subscription_id: 0,
    subscription_status: "",
    sub_start_date: null,
    sub_end_date: null
  };

  const [fieldsData, setfieldsData] = useState(initFields);

  const [subData, setsubData] = useState(initialvalues);

  const showpayingSub = (e) => {
    setsubCount(sub_count);
    setpayingSub(true);
  };

  const editSubscription = (e) => {
    let uri = ENDPOINTS.subscriptions.list.uri;
    uri = uri + "?sub_id=" + sub_id;
    return fetch(uri, {
      method: "GET",
      headers: { "content-type": "application/json" }
    })
      .then((response) => response.json())
      .then((data) => {
        setsubData({
          ...subData,
          sub_type: data.subRec.sub_type,
          sub_count: data.subRec.sub_count,
          avail_space: data.subRec.avail_space,
          total_space: data.subRec.total_space,
          reclaimable_space: data.subRec.reclaimable_space,
          sub_start_date: data.subRec.sub_start_date,
          sub_end_date: data.subRec.sub_end_date,
          status: data.subRec.status,
          edu_inst_name: data.subRec.edu_inst_name,
          addr_line1: data.subRec.addr_line1,
          addr_line2: data.subRec.addr_line2,
          addr_line3: data.subRec.addr_line3,
          city: data.subRec.city,
          state: data.subRec.state,
          zip: data.subRec.zip,
          country_code: data.subRec.country_code,
          edu_inst_ph: data.subRec.edu_inst_ph,
          sub_user_name: data.subRec.sub_user_name,
          sub_user_title: data.subRec.sub_user_title,
          sub_user_ph: data.subRec.sub_user_ph
        });

        setsubEdit(true);
      });
  };

  const getSubRenewalDetails = (e) => {
    let currentDate = new Date(); // Current date
    let uri = ENDPOINTS.subscriptions.list.uri;
    uri = uri + "?sub_id=" + sub_id;
    return fetch(uri, {
      method: "GET",
      headers: { "content-type": "application/json" }
    })
      .then((response) => response.json())
      .then((data) => {
        setsubData({
          ...subData,
          sub_type: data.subRec.sub_type,
          sub_count: data.subRec.sub_count,
          avail_space: data.subRec.avail_space,
          total_space: data.subRec.total_space,
          reclaimable_space: data.subRec.reclaimable_space,
          sub_start_date: data.subRec.sub_start_date,
          sub_end_date: data.subRec.sub_end_date,
          status: data.subRec.status,
          edu_inst_name: data.subRec.edu_inst_name,
          addr_line1: data.subRec.addr_line1,
          addr_line2: data.subRec.addr_line2,
          addr_line3: data.subRec.addr_line3,
          city: data.subRec.city,
          state: data.subRec.state,
          zip: data.subRec.zip,
          country_code: data.subRec.country_code,
          edu_inst_ph: data.subRec.edu_inst_ph,
          sub_user_name: data.subRec.sub_user_name,
          sub_user_title: data.subRec.sub_user_title,
          sub_user_ph: data.subRec.sub_user_ph,
          renewalCount: data.renewalCount,
          renewalUserCount: data.subRenewalRec
            ? data.subRenewalRec.sub_count
            : 0,
          renewalSpace: data.renewalSpace
        });
      });
  };

  const renewSubscription = (e) => {
    let currentDate = new Date(); // Current date
    let uri = ENDPOINTS.subscriptions.list.uri;
    uri = uri + "?sub_id=" + sub_id;
    return fetch(uri, {
      method: "GET",
      headers: { "content-type": "application/json" }
    })
      .then((response) => response.json())
      .then((data) => {
        setsubData({
          ...subData,
          sub_type: data.subRec.sub_type,
          sub_count: data.subRec.sub_count,
          avail_space: data.subRec.avail_space,
          total_space: data.subRec.total_space,
          reclaimable_space: data.subRec.reclaimable_space,
          sub_start_date: data.subRec.sub_start_date,
          sub_end_date: data.subRec.sub_end_date,
          status: data.subRec.status,
          edu_inst_name: data.subRec.edu_inst_name,
          addr_line1: data.subRec.addr_line1,
          addr_line2: data.subRec.addr_line2,
          addr_line3: data.subRec.addr_line3,
          city: data.subRec.city,
          state: data.subRec.state,
          zip: data.subRec.zip,
          country_code: data.subRec.country_code,
          edu_inst_ph: data.subRec.edu_inst_ph,
          sub_user_name: data.subRec.sub_user_name,
          sub_user_title: data.subRec.sub_user_title,
          sub_user_ph: data.subRec.sub_user_ph,
          renewalCount: data.renewalCount,
          renewalUserCount: data.subRenewalRec
            ? data.subRenewalRec.sub_count
            : 0,
          renewalSpace: data.renewalSpace
        });

        let sub_end_date = new Date(data.subRec.sub_end_date);

        var oneMonthAgo = new Date(
          sub_end_date.getFullYear(),
          sub_end_date.getMonth() - 1,
          sub_end_date.getDate()
        );

        if (currentDate <= oneMonthAgo && data.subRec.status !== "EXPIRED") {
          alert("You can only Renew Subscription one month prior to expiry");
          return false;
        }

        setsubRenew(true);
      });
  };

  const manageUsers = (e) => {
    let uri = ENDPOINTS.sub_users.list.uri;
    uri = uri + "?sub_id=" + sub_id;
    return fetch(uri, {
      method: "GET",
      headers: { "content-type": "application/json" }
    })
      .then((response) => response.json())
      .then((response) => {
        setsubUsers(response.subUsers);
        setusersModal(true);
      });
  };

  const addSubUser = (email_id) => {
    let uri = ENDPOINTS.sub_users.list.uri;
    uri = uri + "?sub_id=" + sub_id + "&email_id=" + email_id;

    return fetch(uri, {
      method: "GET",
      headers: { "content-type": "application/json" }
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          alert(data.error);
        } else {
          alert(data.message);
          setusersModal(false);
          manageUsers();
        }
      });
  };

  const manageSpace = (e) => {
    let uri = ENDPOINTS.files.subspace.uri;
    return fetch(uri, {
      method: "GET",
      headers: { "content-type": "application/json" }
    })
      .then((response) => response.json())
      .then((response) => {
        setsubFolders(response.sub_folders);
        setOccupiedSpace(response.total_size);
        setTotalSpace(response.total_space);
        setspaceModal(true);
      });
  };

  const deleteProduct = (product_id) => {
    let uri = ENDPOINTS.files.deleteproduct.uri;
    uri = uri + "?product_id=" + product_id + "&sub_id=" + window.sub_id;
    return fetch(uri, {
      method: "GET",
      headers: { "content-type": "application/json" }
    })
      .then((response) => response.json())
      .then((response) => {
        alert("Product Deleted");
        setspaceModal(false);
        if (subRenew) renewSubscription();
        manageSpace();
      });
  };

  const deleteUser = (user_id) => {
    let uri = ENDPOINTS.sub_users.delete.uri;
    uri = uri + "?user_id=" + user_id + "&sub_id=" + window.sub_id;
    return fetch(uri, {
      method: "DELETE",
      headers: { "content-type": "application/json" }
    })
      .then((response) => response.json())
      .then((response) => {
        alert("Subscription User Removed successfully");
        setusersModal(false);
        manageUsers();
      });
  };

  const deleteSpace = (product_id) => {
    let uri = ENDPOINTS.files.deletespace.uri;
    uri = uri + "?product_id=" + product_id + "&sub_id=" + window.sub_id;
    return fetch(uri, {
      method: "DELETE",
      headers: { "content-type": "application/json" }
    })
      .then((response) => response.json())
      .then((response) => {
        alert("Files Deleted");
        setspaceModal(false);
        if (subRenew) renewSubscription();
        manageSpace();
      });
  };

  const handlesubDataChange = (e) => {
    setsubData({ ...subData, [e.target.name]: e.target.value });
  };

  const handleSubAgree = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation(); // Stop propagation if validation fails
      return;
    }

    if (form.checkValidity()) {
      setFormSubData(event.target);
      setagreeSub(true);
    }
  };

  const handleSubCreate = (e) => {
    // event.preventDefault();

    let spinner = document.getElementById("mySpinner");
    spinner.style.display = "";

    // let formData = formDataToJSON(new FormData(e.target));
    let formData = formDataToJSON(new FormData(formSubData)); //formData is a UseState variable
    let endpoint, url;
    endpoint = ENDPOINTS.subscriptions.create;
    url = endpoint.uri;
    let method = endpoint.method;

    if (formData.sub_type === "AUDIO")
      setsubData({ ...subData, avail_space: "5" });
    if (formData.sub_type === "NOAUDIO")
      setsubData({ ...subData, avail_space: "2" });

    setsubData({ ...subData, total_space: subData.avail_space });

    formData.avail_space = subData.avail_space;
    formData.total_space = subData.total_space;
    formData.reclaimable_space = subData.reclaimable_space;
    formData.sub_start_date = subData.sub_start_date;
    formData.sub_end_date = subData.sub_end_date;
    formData.status = subData.status;

    let ajaxCall = fetch(url, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      method: method,
      body: JSON.stringify(formData)
    });
    return ajaxCall
      .then((response) => response.json())
      .then((data) => {
        let spinner = document.getElementById("mySpinner");
        spinner.style.display = "none";
        if (data.error) {
          alert("Subscription Record Save failed!!\nCheck your Data");
          //alert (data.error.substring(14,75) + '...')
          alert(data.error);
        } else {
          setSubID(data.sub_id);
          setSubType(data.sub_type);
          let subprice =
            countryCode !== "IN"
              ? data.sub_type !== "AUDIO"
                ? 1.0
                : 2.0
              : data.sub_type !== "AUDIO"
              ? 50.0
              : 100.0;
          setSubPrice(subprice);
          alert(
            "Subscription Record Saved Successfully\nProceed to Pay for Subscription"
          );
          setsubCreate(false);

          //window.location.reload();

          //forceUpdate();
          showpayingSub();
        }
      });
  };

  const handleSubEdit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    let spinner = document.getElementById("mySpinner");
    spinner.style.display = "";

    let formData = formDataToJSON(new FormData(e.target));
    let endpoint, url;
    endpoint = ENDPOINTS.subscriptions.update;
    url = endpoint.uri;
    // update: { method: "PUT", uri: "/api/subscriptions" }
    url = url + "?sub_id=" + sub_id;
    let method = endpoint.method;

    let ajaxCall = fetch(url, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      method: method,
      body: JSON.stringify(formData)
    });
    return ajaxCall
      .then((response) => response.json())
      .then((data) => {
        let spinner = document.getElementById("mySpinner");
        spinner.style.display = "none";
        if (data.error) {
          alert("Subscription Record Update failed!!\nCheck your Data");
          //alert (data.error.substring(14,75) + '...')
          alert(data.error);
        } else {
          alert("Subscription Record Updated Successfully");
          setsubEdit(false);
          window.location.reload();
        }
      });
  };

  const handleSubRenew = (e) => {
    e.preventDefault();
    e.stopPropagation();

    let spinner = document.getElementById("mySpinner");
    spinner.style.display = "";

    let formData = formDataToJSON(new FormData(e.target));
    let endpoint, url;
    endpoint = ENDPOINTS.subscriptions.update;
    url = endpoint.uri;
    // update: { method: "PUT", uri: "/api/subscriptions" }
    url = url + "?sub_id=" + sub_id;
    let method = endpoint.method;

    let ajaxCall = fetch(url, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      method: method,
      body: JSON.stringify(formData)
    });
    return ajaxCall
      .then((response) => response.json())
      .then((data) => {
        let spinner = document.getElementById("mySpinner");
        spinner.style.display = "none";
        if (data.error) {
          alert("Subscription Record Update failed!!\nCheck your Data");
          //alert (data.error.substring(14,75) + '...')
          alert(data.error);
        } else {
          alert("Subscription Record Updated Successfully");
          setsubEdit(false);
          window.location.reload();
        }
      });
  };

  function getPurchaseHistory(sub_id) {
    let uri = ENDPOINTS.user_subscriptions.list.uri;
    uri = uri + "?sub_id=" + sub_id;
    return fetch(uri, {
      method: "GET",
      headers: { "content-type": "application/json" }
    })
      .then((response) => response.json())
      .then((response) => {
        setpurchaseHistory(response.user_subscriptions);
      });
  }

  const openFileManager = () => {
    setisFileManagerOpen(!isFileManagerOpen);
    //getPurchaseHistory();
  };

  const showInvoices = (e) => {
    getPurchaseHistory(sub_id);
    setisFileManagerOpen(true);
  };

  function getOrderInvoice(order) {
    return (
      <Modal
        dialogClassName="modal-90w"
        centered="true"
        show={isEditProductClicked}
        onHide={(e) => {
          setcurrentOrder(null);
          setisEditProductClicked(!isEditProductClicked);
        }}
      >
        <Form className="override_form" onSubmit={""}>
          <Modal.Header closeButton>
            <Modal.Title>Invoice</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div id="divToPrint" style={{ justifyContent: "center" }}>
              <div
                id="divToPrint2"
                style={{
                  backgroundColor: "#fff",
                  width: "60%",
                  padding: "50px",
                  minHeight: "297mm",
                  marginLeft: "auto",
                  marginRight: "auto",
                  border: "1px solid",
                  boxShadow: `0 10px 25px rgba(0, 0, 0, 0.5)`
                }}
              >
                <table style={{ width: "100%" }}>
                  <tr>
                    <td>
                      <img
                        src={composzLogoBlack}
                        style={{ height: "70px", marginBottom: "10px" }}
                      />
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <span
                        style={{
                          fontSize: "34px",
                          color: "#0070c0",
                          fontWeight: "34px"
                        }}
                      >
                        <b>INVOICE</b>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold" }}>COMPOSZ LLC,</td>{" "}
                    <td style={{ textAlign: "right" }}>
                      Invoice #: INVSUB000{order.id}
                    </td>
                  </tr>
                  <tr>
                    <td>#121 HAUT BRION AVENUE</td>{" "}
                    <td style={{ textAlign: "right" }}>
                      Invoice Date: {order.updated_at}
                    </td>
                  </tr>
                  <tr>
                    <td>NEWARK, DE-19702.</td>{" "}
                    <td style={{ textAlign: "right" }}>
                      Invoice Amount:
                      {formatCurrency(order.total_amount, 1, "USD")}
                      {/* {(order.total_amount / 100).toFixed(2)} */}
                    </td>
                  </tr>
                  <tr>
                    <td></td>{" "}
                    <td style={{ textAlign: "right" }}>
                      Status:{" "}
                      <span style={{ color: "#92d050", fontSize: "20px" }}>
                        PAID
                      </span>
                    </td>
                  </tr>
                </table>
                <span>
                  <b>BILLED TO</b>
                </span>
                <p>
                  <span>{order.full_name}</span>
                  <br />
                  <span>{order.email}</span>
                  <br />
                  <span>{order.pg_user_email}</span>
                  <br />
                  <span>{order.address}</span>
                  <br />
                  {/* <span>Bangalore, 560076.</span> */}
                </p>
                <br />
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr
                      style={{
                        borderBottom: "0.5px solid black",
                        borderTop: "0.5px solid black"
                      }}
                    >
                      <th>Description</th>
                      <th>Price</th>
                      <th>No. of Students</th>
                      <th>Amount</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>Online School Pictures Builder</td>
                      <td>{formatCurrency(order.price, 1, "USD")}</td>
                      <td style={{ paddingLeft: "25px" }}>{order.sub_count}</td>
                      <td>
                        {formatCurrency(
                          order.sub_count * order.price,
                          1,
                          "USD"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Subscription Charges</td>
                    </tr>
                  </tbody>
                </table>
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th>PAYMENT DETAILS</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Paypal Transaction ID: {order.paypal_capture_id}</td>
                      <td style={{ textAlign: "right" }}>
                        Item (s) Subtotal:{" "}
                        {formatCurrency(
                          order.sub_count * order.price,
                          1,
                          "USD"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td style={{ textAlign: "right" }}>
                        Convenience charges (5%):{" "}
                        {formatCurrency(
                          order.sub_count *
                            order.price *
                            order.pg_transaction_fee,
                          1,
                          "USD"
                        )}
                        {/* {(order.pg_transaction_fee / 100).toFixed(2)} */}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td style={{ textAlign: "right" }}>
                        Tax to be collected: {formatCurrency(0, 1, "USD")}
                        {/* ${(order.pg_fixed_fee / 100).toFixed(2)} */}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td style={{ textAlign: "right" }}>
                        <b>
                          GRAND TOTAL:{" "}
                          {formatCurrency(order.total_amount, 1, "USD")}
                          {/* {(order.total_amount / 100).toFixed(2)} */}
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <p>Thanks for your purchase</p>
                <p>-- team Composz</p>

                <br></br>
                <br></br>
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr
                      style={{
                        borderBottom: "0.5px solid black",
                        borderTop: "0.5px solid black"
                      }}
                    >
                      <th style={{ textAlign: "center", color: "darkgreen" }}>
                        composz.com is owned, operated & managed by COMPOSZ LLC
                      </th>
                    </tr>
                  </thead>
                </table>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="button"
              onClick={() => {
                printDocument(`INVSUB000${order.id}`);
              }}
            >
              Download
            </Button>
            <Button
              onClick={(e) => {
                setisEditProductClicked(!isEditProductClicked);
              }}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }

  function getrazorpayOrderInvoice(order) {
    let user = {};
    return (
      <Modal
        id="Mymodal"
        dialogClassName="modal-90w"
        centered="true"
        show={isEditProductClicked}
        onHide={(e) => {
          setcurrentOrder(null);
          setisEditProductClicked(false);
        }}
      >
        <Form className="override_form" onSubmit={""}>
          <Modal.Header closeButton>
            <Modal.Title>Invoice</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div id="divToPrint" style={{ justifyContent: "center" }}>
              <div
                id="divToPrint2"
                // className="mt4"
                style={{
                  backgroundColor: "#fff",
                  width: "60%",
                  padding: "50px",
                  minHeight: "297mm",
                  marginLeft: "auto",
                  marginRight: "auto",
                  border: "1px solid",
                  boxShadow: `0 10px 25px rgba(0, 0, 0, 0.5)`
                }}
              >
                <table style={{ width: "100%" }}>
                  <tr>
                    <td>
                      <img
                        src={composzLogoBlack}
                        style={{ height: "70px", marginBottom: "5px" }}
                      />
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <span
                        style={{
                          fontSize: "34px",
                          color: "#0070c0",
                          fontWeight: "34px"
                        }}
                      >
                        <b>INVOICE</b>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold" }}>LIFE COLORS,</td>{" "}
                    <td style={{ textAlign: "right" }}>
                      Invoice #: INVSUB000{order.id}
                    </td>
                  </tr>
                  <tr>
                    <td>#9, 4th Cross, Kothanur Main Road,</td>{" "}
                    <td style={{ textAlign: "right" }}>
                      Invoice Date: {order.updated_at}
                    </td>
                  </tr>
                  <tr>
                    <td>Bangalore 560 062.</td>{" "}
                    <td style={{ textAlign: "right" }}>
                      Invoice Amount:{" "}
                      {formatCurrency(order.total_amount, 1, "INR")}
                      {/* {(order.total_amount / 100).toFixed(2)} */}
                    </td>
                  </tr>
                  <tr>
                    <td>GSTIN: 29AUTPB5544P1ZS; GST SAC Code: 998434</td>{" "}
                    <td style={{ textAlign: "right" }}>
                      Status:{" "}
                      <span style={{ color: "#92d050", fontSize: "20px" }}>
                        PAID
                      </span>
                    </td>
                  </tr>
                </table>
                <span>
                  <b>BILLED TO</b>
                </span>
                <p>
                  <br></br>
                  <span>{order.user_name}</span>
                  <br></br>
                  <span>{order.razorpay_capture.email}</span>
                  <br></br>
                  <span>{order.razorpay_capture.contact}</span>
                  <br />
                </p>
                <br />
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr
                      style={{
                        borderBottom: "0.5px solid black",
                        borderTop: "0.5px solid black"
                      }}
                    >
                      <th>Description</th>
                      <th>Price</th>
                      <th>No. of Students</th>
                      <th>Amount</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>Online School Pictures Builder</td>
                      <td>{formatCurrency(order.price, 1, "INR")}</td>
                      <td style={{ paddingLeft: "25px" }}>{order.sub_count}</td>
                      <td>
                        {formatCurrency(
                          order.sub_count * order.price,
                          1,
                          "INR"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Subscription Charges</td>
                    </tr>
                  </tbody>
                </table>
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th>PAYMENT DETAILS</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Razorpay Payment ID: {order.razorpay_capture.id}</td>
                      <td style={{ textAlign: "right" }}>
                        Item (s) Subtotal:{" "}
                        {formatCurrency(
                          order.sub_count * order.price,
                          1,
                          "INR"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Payment Mode: {order.razorpay_capture.method}
                        {order.razorpay_capture.method == "netbanking"
                          ? "-" + order.razorpay_capture.bank
                          : ""}
                        {order.razorpay_capture.method == "card"
                          ? "-" +
                            order.razorpay_capture.card.network +
                            "-xxxx-" +
                            order.razorpay_capture.card.last4
                          : ""}
                        {order.razorpay_capture.method == "upi"
                          ? "-" +
                            order.razorpay_capture.vpa +
                            "-Ph:" +
                            order.razorpay_capture.acquirer_data.rrn
                          : ""}
                        {order.razorpay_capture.method == "wallet"
                          ? "-" + order.razorpay_capture.wallet
                          : ""}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        Convenience charges:{" "}
                        {formatCurrency(
                          order.sub_count *
                            order.price *
                            order.pg_transaction_fee,
                          1,
                          "INR"
                        )}
                        {/* {(order.pg_transaction_fee / 100).toFixed(2)} */}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Transaction ID:
                        {order.razorpay_capture.method == "netbanking"
                          ? order.razorpay_capture.acquirer_data
                              .bank_transaction_id
                          : ""}
                        {order.razorpay_capture.method == "card"
                          ? order.razorpay_capture.acquirer_data.auth_code
                          : ""}
                        {order.razorpay_capture.method == "upi"
                          ? order.razorpay_capture.acquirer_data
                              .upi_transaction_id
                          : ""}
                        {order.razorpay_capture.method == "wallet"
                          ? " N/A"
                          : ""}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        GST 18%:{" "}
                        {formatCurrency(
                          (order.sub_count * order.price +
                            order.sub_count *
                              order.price *
                              order.pg_transaction_fee) *
                            0.18,
                          1,
                          "INR"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td style={{ textAlign: "right" }}>
                        <b>
                          GRAND TOTAL (rounded):{" "}
                          {formatCurrency(order.total_amount, 1, "INR")}
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <p> Thanks for your purchase</p>
                <p> --team Composz</p>

                <br></br>
                <br></br>
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr
                      style={{
                        borderBottom: "0.5px solid black",
                        borderTop: "0.5px solid black"
                      }}
                    >
                      <th style={{ textAlign: "center", color: "darkgreen" }}>
                        composz.com is owned, operated & managed by LIFE COLORS
                      </th>
                    </tr>
                  </thead>
                </table>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="button"
              onClick={() => {
                printDocument(`INVSUB000${order.id}`);
              }}
            >
              Download
            </Button>
            <Button
              onClick={(e) => {
                setisEditProductClicked(false);
              }}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }

  function printDocument(orderId) {
    const input = document.getElementById("divToPrint2");
    html2canvas(input, { scale: 3 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg");
      const pdf = new jsPDF();
      var width = pdf.internal.pageSize.getWidth();
      var height = pdf.internal.pageSize.getHeight();

      pdf.addImage(imgData, "JPEG", 0, 0, width, height);

      //pdf.output('dataurlnewwindow');
      pdf.save(`${orderId}.pdf`);
    });
  }

  return window.innerWidth > 450 ? (
    <Navbar
      expand="lg"
      inverse
      collapseOnSelect
      style={{
        paddingLeft: "180px",
        borderRadius: "0px",
        backgroundColor: "#000",
        color: "#fff",
        position: "sticky",
        zIndex: 1000,
        minHeight: "52px",
        maxHeight: "52px"
      }}
      variant="dark"
      fixed="top"
    >
      <Navbar.Collapse>
        <Nav>
          <NavItem eventKey={2} href="/">
            <img height="50px" src={logo} style={{ paddingBottom: "10px" }} />
          </NavItem>
          {user_id === -1 ? (
            <Nav style={{ paddingTop: "7px" }}>
              <NavItem eventKey={2} href="#">
                {""}
              </NavItem>
              <NavItem eventKey={2} href="#">
                {""}
              </NavItem>
              <NavItem eventKey={2} href="#">
                {""}
              </NavItem>
            </Nav>
          ) : null}
          <NavItem eventKey={2} href="#">
            {""}
          </NavItem>
          <NavItem
            eventKey={1}
            href="/static/Learn.html"
            target="blank"
            style={{ paddingTop: "7px" }}
          >
            Learn
          </NavItem>

          {user_id === -1 ? (
            <NavDropdown
              eventKey={3}
              title="Audience"
              id="1"
              style={{ paddingTop: "7px" }}
              onMouseEnter={showDropdown}
              onMouseLeave={hideDropdown}
              open={show}
              onToggle={handleToggle}
            >
              <MenuItem
                eventKey={3.1}
                href="/static/Schools.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Schools
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.2}
                href="/static/Colleges.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Colleges
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.3}
                href="/static/Students.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Students
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.4}
                href="/static/AlumniStudents.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Alumni Students
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.5}
                href="/static/Photographers.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Photographers
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.6}
                href="/static/Groups.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Groups
                </span>
              </MenuItem>
            </NavDropdown>
          ) : (
            <NavItem eventKey={2} href="#">
              {""}
            </NavItem>
          )}
          {user_id === -1 ? (
            <NavDropdown
              eventKey={3}
              title="Products"
              id="2"
              style={{ paddingTop: "7px" }}
              onMouseEnter={showDropdown1}
              onMouseLeave={hideDropdown1}
              open={show1}
              onToggle={handleToggle}
            >
              <MenuItem
                eventKey={3.1}
                href="/static/Composites.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Composites
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.2}
                href="/static/PictureBooklets.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Picture Booklets
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.3}
                href="/static/SportsBooklets.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Sports Booklets
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.4}
                href="/static/GraduationFolders.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Graduation Folders
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.5}
                href="/static/CustomYearBooks.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Custom Year Books
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.6}
                href="/static/ReportCardFolders.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Report Card Folders
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.7}
                href="/static/PortraitSheets.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Portrait Sheets
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.8}
                href="/static/PassportSheets.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Passport Sheets
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.9}
                href="/static/IDCardSheets.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  ID Card Sheets
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.1}
                href="/static/CustomCertificates.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Custom Certificates
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.11}
                href="/static/OtherProducts.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Other Products
                </span>
              </MenuItem>
            </NavDropdown>
          ) : (
            <NavItem eventKey={2} href="#">
              {""}
            </NavItem>
          )}

          <NavItem eventKey={2} href="#">
            {""}
          </NavItem>
        </Nav>
        {user_id != -1 ? (
          <Nav style={{ paddingTop: "7px" }}>
            <NavItem eventKey={2} href="#">
              {""}
            </NavItem>
            <NavItem eventKey={2} href="#">
              {""}
            </NavItem>
            <NavItem eventKey={2} href="#">
              {""}
            </NavItem>
            <NavItem eventKey={2} href="#">
              {""}
            </NavItem>
          </Nav>
        ) : (
          <Nav style={{ paddingTop: "7px" }}>
            <NavItem eventKey={2} href="#">
              {""}
            </NavItem>
            <NavItem eventKey={2} href="#">
              {""}
            </NavItem>
            <NavItem eventKey={1} href="/presets">
              Presets
            </NavItem>

            {window.subscription_status != "EXPIRED" ? (
              <NavDropdown
                eventKey={3}
                title="Dashboard"
                id="3"
                onMouseEnter={showDropdown2}
                onMouseLeave={hideDropdown2}
                open={show2}
                onToggle={handleToggle}
              >
                <MenuItem
                  eventKey={3.1}
                  href="/products/add"
                  style={{ backgroundColor: "#000000" }}
                >
                  <span
                    style={{
                      color: "white",
                      fontWeight: "normal",
                      fontSize: "125%"
                    }}
                  >
                    Parents: Add your School's View/Pay Products
                  </span>
                </MenuItem>
              </NavDropdown>
            ) : (
              ""
            )}
          </Nav>
        )}
        {user_id != -1 ? (
          <Nav pullRight>
            <NavItem eventKey={2} href="#">
              {""}
            </NavItem>
            <NavItem eventKey={2} href="#">
              {""}
            </NavItem>

            {window.sub_id == 0 || window.subscription_status != "EXPIRED" ? (
              <Fragment>
                {window.sub_id == 0 || window.sub_avail_space > 0 ? (
                  <NavItem
                    eventKey={1}
                    href="/presets"
                    style={{ paddingTop: "7px" }}
                  >
                    Presets
                  </NavItem>
                ) : (
                  ""
                )}

                <NavDropdown
                  eventKey={3}
                  title="Dashboard"
                  id="3"
                  style={{ paddingTop: "7px" }}
                  onMouseEnter={showDropdown2}
                  onMouseLeave={hideDropdown2}
                  open={show2}
                  onToggle={handleToggle}
                >
                  <MenuItem
                    eventKey={3.1}
                    href="/products"
                    style={{ backgroundColor: "#000000" }}
                  >
                    <span
                      style={{
                        color: "white",
                        fontWeight: "normal",
                        fontSize: "125%"
                      }}
                    >
                      My Products
                    </span>
                  </MenuItem>
                  {has_view_products ? (
                    <MenuItem
                      eventKey={3.2}
                      href="/orders"
                      target="blank"
                      style={{ backgroundColor: "#000000" }}
                    >
                      <span
                        style={{
                          color: "white",
                          fontWeight: "normal",
                          fontSize: "125%"
                        }}
                      >
                        View/Pay Products
                      </span>
                    </MenuItem>
                  ) : (
                    <MenuItem
                      eventKey={3.2}
                      href="/products/add"
                      target="blank"
                      style={{ backgroundColor: "#000000" }}
                    >
                      <span
                        style={{
                          color: "white",
                          fontWeight: "normal",
                          fontSize: "125%"
                        }}
                      >
                        Add View/Pay Products
                      </span>
                    </MenuItem>
                  )}
                </NavDropdown>
              </Fragment>
            ) : (
              ""
            )}

            {sub_id < 1 ? (
              <Fragment>
                <NavDropdown
                  eventKey={3}
                  title="Subscription"
                  id="2"
                  style={{ paddingTop: "7px" }}
                  onMouseEnter={showDropdown1}
                  onMouseLeave={hideDropdown1}
                  open={show1}
                  onToggle={handleToggle}
                >
                  <MenuItem
                    eventKey={2.1}
                    onClick={purchaseSubscription}
                    style={{ backgroundColor: "#000000" }}
                  >
                    <span
                      style={{
                        color: "white",
                        fontWeight: "normal",
                        fontSize: "125%"
                      }}
                    >
                      Purchase
                    </span>
                  </MenuItem>
                </NavDropdown>

                <NavItem
                  eventKey={1}
                  href="/orders/cart"
                  style={{ paddingTop: "7px" }}
                >
                  Cart (
                  <span
                    id="carCounter"
                    style={{ color: "green", fontWeight: "bold" }}
                  >
                    {cartItems.quantity === null ? (
                      <i
                        className="fa fa-shopping-cart"
                        height="20px"
                        aria-hidden="true"
                      ></i>
                    ) : (
                      cartItems.quantity
                    )}
                  </span>
                  )
                </NavItem>
              </Fragment>
            ) : (
              <Fragment>
                {sub_role === "Y" ? (
                  <Fragment>
                    <NavDropdown
                      eventKey={4}
                      title="Subscription"
                      id="2"
                      style={{ paddingTop: "7px" }}
                      onMouseEnter={showDropdown1}
                      onMouseLeave={hideDropdown1}
                      open={show1}
                      onToggle={handleToggle}
                    >
                      <MenuItem
                        eventKey={4.2}
                        onClick={editSubscription}
                        style={{ backgroundColor: "#000000" }}
                      >
                        <span
                          style={{
                            color: "white",
                            fontWeight: "normal",
                            fontSize: "125%"
                          }}
                        >
                          Subscription Details
                        </span>
                      </MenuItem>
                      {subscription_status != "EXPIRED" ? (
                        <MenuItem
                          eventKey={4.1}
                          onClick={manageUsers}
                          style={{ backgroundColor: "#000000" }}
                        >
                          <span
                            style={{
                              color: "white",
                              fontWeight: "normal",
                              fontSize: "125%"
                            }}
                          >
                            Manage Users
                          </span>
                        </MenuItem>
                      ) : (
                        ""
                      )}
                      <MenuItem
                        eventKey={4.8}
                        onClick={manageSpace}
                        style={{ backgroundColor: "#000000" }}
                      >
                        <span
                          style={{
                            color: "white",
                            fontWeight: "normal",
                            fontSize: "125%"
                          }}
                        >
                          Manage Space
                        </span>
                      </MenuItem>
                      <MenuItem
                        eventKey={4.2}
                        onClick={renewSubscription}
                        style={{ backgroundColor: "#000000" }}
                      >
                        <span
                          style={{
                            color: "white",
                            fontWeight: "normal",
                            fontSize: "125%"
                          }}
                        >
                          Renew Subscription
                        </span>
                      </MenuItem>
                      <MenuItem
                        eventKey={4.3}
                        // onClick={showpayingSub}
                        onClick={(e) => {
                          setSubType(sub_type);
                          setSubPrice(price);
                          showpayingSub();
                        }}
                        style={{ backgroundColor: "#000000" }}
                      >
                        <span
                          style={{
                            color: "white",
                            fontWeight: "normal",
                            fontSize: "125%"
                          }}
                        >
                          Payment - Subscription / Additional Students
                        </span>
                      </MenuItem>
                      <MenuItem
                        eventKey={4.3}
                        onClick={showInvoices}
                        style={{ backgroundColor: "#000000" }}
                      >
                        <span
                          style={{
                            color: "white",
                            fontWeight: "normal",
                            fontSize: "125%"
                          }}
                        >
                          Invoice(s)
                        </span>
                      </MenuItem>
                    </NavDropdown>
                  </Fragment>
                ) : (
                  ""
                )}

                {window.subscription_status != "EXPIRED" ? (
                  <NavItem
                    eventKey={1}
                    href="/orders/cart"
                    style={{ paddingTop: "7px" }}
                  >
                    Download (
                    <span
                      id="carCounter"
                      style={{ color: "green", fontWeight: "bold" }}
                    >
                      {cartItems.quantity === null ? (
                        <i
                          className="fa fa-shopping-cart"
                          height="20px"
                          aria-hidden="true"
                        ></i>
                      ) : (
                        cartItems.quantity
                      )}
                    </span>
                    )
                  </NavItem>
                ) : (
                  ""
                )}
              </Fragment>
            )}

            <NavDropdown
              eventKey={2}
              id="4"
              title={
                <img
                  height="20px"
                  src={profile}
                  style={{ paddingTop: "3px" }}
                />
              }
              onMouseEnter={showDropdown3}
              onMouseLeave={hideDropdown3}
              open={show3}
              style={{ paddingTop: "3px" }}
              onToggle={handleToggle}
            >
              <li className="dropdown-header">
                <span
                  style={{
                    textAlign: "center",
                    color: "gray",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Logged in as:{" "}
                </span>
                <br></br>
                <span
                  style={{
                    textAlign: "center",
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "125%"
                  }}
                >
                  {user_name}
                </span>
                <br></br>
                <span
                  style={{
                    textAlign: "center",
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "125%"
                  }}
                >
                  {user_email}
                </span>
                <br></br>
                <span
                  style={{
                    textAlign: "center",
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "125%"
                  }}
                >
                  {sub_id != 0
                    ? `(subscription user)`
                    : `(non-subscription user)`}
                </span>
              </li>
              <MenuItem
                eventKey={3.1}
                href="/users/sign_out"
                data-method="delete"
                style={{ backgroundColor: "#ff0000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Log out
                </span>
              </MenuItem>
            </NavDropdown>
          </Nav>
        ) : (
          <Nav pullRight style={{ paddingTop: "7px" }}>
            <NavItem eventKey={1} href="/users/sign_in">
              Login
            </NavItem>
          </Nav>
        )}

        <Modal
          show={subCreate || subEdit}
          dialogClassName="modal-90w"
          centered="true"
          onHide={() => {
            setsubCreate(false);
            setsubEdit(false);
          }}
          style={{ marginTop: "45px" }}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Subscription Details - Status
              {subData.status !== "ACTIVE" ? (
                subData.status !== "EXPIRED" ? (
                  <span style={{ color: "red" }}> - Pending Payment</span>
                ) : (
                  <span style={{ color: "red" }}>
                    {" "}
                    - Expired - Renew Immediately
                  </span>
                )
              ) : (
                <span style={{ color: "green" }}> - Active</span>
              )}
            </Modal.Title>
          </Modal.Header>

          <Form
            // onSubmit={subEdit ? handleSubEdit : handleSubCreate}
            onSubmit={subEdit ? handleSubEdit : handleSubAgree}
            className="override_form"
          >
            <Modal.Body>
              <br></br>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div style={{ width: "76%" }}>
                    <FieldGroup
                      type="text"
                      label="Educational Institution Name:"
                      value={subData.edu_inst_name}
                      name="edu_inst_name"
                      id="edu_inst_name"
                      required="required"
                      onChange={handlesubDataChange}
                      readOnly={subEdit && sub_count != 0 ? "readonly" : ""}
                    ></FieldGroup>
                  </div>
                  <div style={{ marginLeft: "10px", width: "23%" }}>
                    <FieldGroup
                      type="text"
                      label="Educational Institution Phone:"
                      value={subData.edu_inst_ph}
                      name="edu_inst_ph"
                      id="edu_inst_ph"
                      required="required"
                      onChange={handlesubDataChange}
                      // readOnly = {subEdit?"readonly":""}
                    ></FieldGroup>
                  </div>
                </div>

                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div style={{ width: "33%" }}>
                    <FieldGroup
                      type="text"
                      label="Educational Institution Address Line1:"
                      value={subData.addr_line1}
                      name="addr_line1"
                      id="addr_line1"
                      required="required"
                      onChange={handlesubDataChange}
                      readOnly={subEdit && sub_count != 0 ? "readonly" : ""}
                    ></FieldGroup>
                  </div>
                  <div style={{ marginLeft: "10px", width: "33%" }}>
                    <FieldGroup
                      type="text"
                      label="Educational Institution Address Line2:"
                      value={subData.addr_line2}
                      name="addr_line2"
                      id="addr_line2"
                      required="required"
                      onChange={handlesubDataChange}
                      readOnly={subEdit && sub_count != 0 ? "readonly" : ""}
                    ></FieldGroup>
                  </div>
                  <div style={{ marginLeft: "10px", width: "32.5%" }}>
                    <FieldGroup
                      type="text"
                      label="Educational Institution Address Line3:"
                      value={subData.addr_line3}
                      name="addr_line3"
                      id="addr_line3"
                      // required="required"
                      onChange={handlesubDataChange}
                      readOnly={subEdit && sub_count != 0 ? "readonly" : ""}
                    ></FieldGroup>
                  </div>
                </div>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div style={{ width: "23.7%" }}>
                    <FieldGroup
                      type="text"
                      label="City:"
                      value={subData.city}
                      name="city"
                      id="city"
                      required="required"
                      onChange={handlesubDataChange}
                      readOnly={subEdit && sub_count != 0 ? "readonly" : ""}
                    ></FieldGroup>
                  </div>
                  <div style={{ marginLeft: "10px", width: "23%" }}>
                    <FieldGroup
                      type="text"
                      label="State"
                      value={subData.state}
                      name="state"
                      id="state"
                      required="required"
                      onChange={handlesubDataChange}
                      readOnly={subEdit && sub_count != 0 ? "readonly" : ""}
                    ></FieldGroup>
                  </div>
                  <div style={{ marginLeft: "10px", width: "18%" }}>
                    <FieldGroup
                      type="text"
                      label="PIN/ZIP Code:"
                      value={subData.zip}
                      name="zip"
                      id="zip"
                      required="required"
                      onChange={handlesubDataChange}
                      readOnly={subEdit && sub_count != 0 ? "readonly" : ""}
                    ></FieldGroup>
                  </div>
                  <div style={{ marginLeft: "10px", width: "33%" }}>
                    {/* <FieldGroup
                      type="text"
                      label="Country:"
                      value={subData.country_code}
                      name="country_code"
                      id="country_code"
                      required="required"
                      onChange={handlesubDataChange}
                      readOnly={subEdit && sub_count != 0 ? "readonly" : ""}
                    ></FieldGroup> */}

                    <FieldGroup
                      componentClass="select"
                      id="formControlPreset"
                      label="Choose a Country:"
                      value={subData.country_code}
                      name="country_code"
                      required="required"
                      onChange={handlesubDataChange}
                      disabled={subEdit && sub_count != 0}
                    >
                      <option value="ABW">Aruba</option>
                      <option value="AFG">Afghanistan</option>
                      <option value="AGO">Angola</option>
                      <option value="AIA">Anguilla</option>
                      <option value="ALA">Åland Islands</option>
                      <option value="ALB">Albania</option>
                      <option value="AND">Andorra</option>
                      <option value="ARE">United Arab Emirates (the)</option>
                      <option value="ARG">Argentina</option>
                      <option value="ARM">Armenia</option>
                      <option value="ASM">American Samoa</option>
                      <option value="ATA">Antarctica</option>
                      <option value="ATF">
                        French Southern Territories (the)
                      </option>
                      <option value="ATG">Antigua and Barbuda</option>
                      <option value="AUS">Australia</option>
                      <option value="AUT">Austria</option>
                      <option value="AZE">Azerbaijan</option>
                      <option value="BDI">Burundi</option>
                      <option value="BEL">Belgium</option>
                      <option value="BEN">Benin</option>
                      <option value="BES">
                        Bonaire, Sint Eustatius and Saba
                      </option>
                      <option value="BFA">Burkina Faso</option>
                      <option value="BGD">Bangladesh</option>
                      <option value="BGR">Bulgaria</option>
                      <option value="BHR">Bahrain</option>
                      <option value="BHS">Bahamas (the)</option>
                      <option value="BIH">Bosnia and Herzegovina</option>
                      <option value="BLM">Saint Barthélemy</option>
                      <option value="BLR">Belarus</option>
                      <option value="BLZ">Belize</option>
                      <option value="BMU">Bermuda</option>
                      <option value="BOL">
                        Bolivia (Plurinational State of)
                      </option>
                      <option value="BRA">Brazil</option>
                      <option value="BRB">Barbados</option>
                      <option value="BRN">Brunei Darussalam</option>
                      <option value="BTN">Bhutan</option>
                      <option value="BVT">Bouvet Island</option>
                      <option value="BWA">Botswana</option>
                      <option value="CAF">
                        Central African Republic (the)
                      </option>
                      <option value="CAN">Canada</option>
                      <option value="CCK">Cocos (Keeling) Islands (the)</option>
                      <option value="CHE">Switzerland</option>
                      <option value="CHL">Chile</option>
                      <option value="CHN">China</option>
                      <option value="CIV">Côte d'Ivoire</option>
                      <option value="CMR">Cameroon</option>
                      <option value="COD">
                        Congo (the Democratic Republic of the)
                      </option>
                      <option value="COG">Congo (the)</option>
                      <option value="COK">Cook Islands (the)</option>
                      <option value="COL">Colombia</option>
                      <option value="COM">Comoros (the)</option>
                      <option value="CPV">Cabo Verde</option>
                      <option value="CRI">Costa Rica</option>
                      <option value="CUB">Cuba</option>
                      <option value="CUW">Curaçao</option>
                      <option value="CXR">Christmas Island</option>
                      <option value="CYM">Cayman Islands (the)</option>
                      <option value="CYP">Cyprus</option>
                      <option value="CZE">Czechia</option>
                      <option value="DEU">Germany</option>
                      <option value="DJI">Djibouti</option>
                      <option value="DMA">Dominica</option>
                      <option value="DNK">Denmark</option>
                      <option value="DOM">Dominican Republic (the)</option>
                      <option value="DZA">Algeria</option>
                      <option value="ECU">Ecuador</option>
                      <option value="EGY">Egypt</option>
                      <option value="ERI">Eritrea</option>
                      <option value="ESH">Western Sahara*</option>
                      <option value="ESP">Spain</option>
                      <option value="EST">Estonia</option>
                      <option value="ETH">Ethiopia</option>
                      <option value="FIN">Finland</option>
                      <option value="FJI">Fiji</option>
                      <option value="FLK">
                        Falkland Islands (the) [Malvinas]
                      </option>
                      <option value="FRA">France</option>
                      <option value="FRO">Faroe Islands (the)</option>
                      <option value="FSM">
                        Micronesia (Federated States of)
                      </option>
                      <option value="GAB">Gabon</option>
                      <option value="GBR">
                        United Kingdom of Great Britain and Northern Ireland
                        (the)
                      </option>
                      <option value="GEO">Georgia</option>
                      <option value="GGY">Guernsey</option>
                      <option value="GHA">Ghana</option>
                      <option value="GIB">Gibraltar</option>
                      <option value="GIN">Guinea</option>
                      <option value="GLP">Guadeloupe</option>
                      <option value="GMB">Gambia (the)</option>
                      <option value="GNB">Guinea-Bissau</option>
                      <option value="GNQ">Equatorial Guinea</option>
                      <option value="GRC">Greece</option>
                      <option value="GRD">Grenada</option>
                      <option value="GRL">Greenland</option>
                      <option value="GTM">Guatemala</option>
                      <option value="GUF">French Guiana</option>
                      <option value="GUM">Guam</option>
                      <option value="GUY">Guyana</option>
                      <option value="HKG">Hong Kong</option>
                      <option value="HMD">
                        Heard Island and McDonald Islands
                      </option>
                      <option value="HND">Honduras</option>
                      <option value="HRV">Croatia</option>
                      <option value="HTI">Haiti</option>
                      <option value="HUN">Hungary</option>
                      <option value="IDN">Indonesia</option>
                      <option value="IMN">Isle of Man</option>
                      {countryCode !== "IN" ? (
                        <option value="IND">India</option>
                      ) : (
                        <option value="IND" selected="selected">
                          India
                        </option>
                      )}
                      <option value="IOT">
                        British Indian Ocean Territory (the)
                      </option>
                      <option value="IRL">Ireland</option>
                      <option value="IRN">Iran (Islamic Republic of)</option>
                      <option value="IRQ">Iraq</option>
                      <option value="ISL">Iceland</option>
                      <option value="ISR">Israel</option>
                      <option value="ITA">Italy</option>
                      <option value="JAM">Jamaica</option>
                      <option value="JEY">Jersey</option>
                      <option value="JOR">Jordan</option>
                      <option value="JPN">Japan</option>
                      <option value="KAZ">Kazakhstan</option>
                      <option value="KEN">Kenya</option>
                      <option value="KGZ">Kyrgyzstan</option>
                      <option value="KHM">Cambodia</option>
                      <option value="KIR">Kiribati</option>
                      <option value="KNA">Saint Kitts and Nevis</option>
                      <option value="KOR">Korea (the Republic of)</option>
                      <option value="KWT">Kuwait</option>
                      <option value="LAO">
                        Lao People's Democratic Republic (the)
                      </option>
                      <option value="LBN">Lebanon</option>
                      <option value="LBR">Liberia</option>
                      <option value="LBY">Libya</option>
                      <option value="LCA">Saint Lucia</option>
                      <option value="LIE">Liechtenstein</option>
                      <option value="LKA">Sri Lanka</option>
                      <option value="LSO">Lesotho</option>
                      <option value="LTU">Lithuania</option>
                      <option value="LUX">Luxembourg</option>
                      <option value="LVA">Latvia</option>
                      <option value="MAC">Macao</option>
                      <option value="MAF">Saint Martin (French part)</option>
                      <option value="MAR">Morocco</option>
                      <option value="MCO">Monaco</option>
                      <option value="MDA">Moldova (the Republic of)</option>
                      <option value="MDG">Madagascar</option>
                      <option value="MDV">Maldives</option>
                      <option value="MEX">Mexico</option>
                      <option value="MHL">Marshall Islands (the)</option>
                      <option value="MKD">North Macedonia</option>
                      <option value="MLI">Mali</option>
                      <option value="MLT">Malta</option>
                      <option value="MMR">Myanmar</option>
                      <option value="MNE">Montenegro</option>
                      <option value="MNG">Mongolia</option>
                      <option value="MNP">
                        Northern Mariana Islands (the)
                      </option>
                      <option value="MOZ">Mozambique</option>
                      <option value="MRT">Mauritania</option>
                      <option value="MSR">Montserrat</option>
                      <option value="MTQ">Martinique</option>
                      <option value="MUS">Mauritius</option>
                      <option value="MWI">Malawi</option>
                      <option value="MYS">Malaysia</option>
                      <option value="MYT">Mayotte</option>
                      <option value="NAM">Namibia</option>
                      <option value="NCL">New Caledonia</option>
                      <option value="NER">Niger (the)</option>
                      <option value="NFK">Norfolk Island</option>
                      <option value="NGA">Nigeria</option>
                      <option value="NIC">Nicaragua</option>
                      <option value="NIU">Niue</option>
                      <option value="NLD">Netherlands (Kingdom of the)</option>
                      <option value="NOR">Norway</option>
                      <option value="NPL">Nepal</option>
                      <option value="NRU">Nauru</option>
                      <option value="NZL">New Zealand</option>
                      <option value="OMN">Oman</option>
                      <option value="PAK">Pakistan</option>
                      <option value="PAN">Panama</option>
                      <option value="PCN">Pitcairn</option>
                      <option value="PER">Peru</option>
                      <option value="PHL">Philippines (the)</option>
                      <option value="PLW">Palau</option>
                      <option value="PNG">Papua New Guinea</option>
                      <option value="POL">Poland</option>
                      <option value="PRI">Puerto Rico</option>
                      <option value="PRK">
                        Korea (the Democratic People's Republic of)
                      </option>
                      <option value="PRT">Portugal</option>
                      <option value="PRY">Paraguay</option>
                      <option value="PSE">Palestine, State of</option>
                      <option value="PYF">French Polynesia</option>
                      <option value="QAT">Qatar</option>
                      <option value="REU">Réunion</option>
                      <option value="ROU">Romania</option>
                      <option value="RUS">Russian Federation (the)</option>
                      <option value="RWA">Rwanda</option>
                      <option value="SAU">Saudi Arabia</option>
                      <option value="SDN">Sudan (the)</option>
                      <option value="SEN">Senegal</option>
                      <option value="SGP">Singapore</option>
                      <option value="SGS">
                        South Georgia and the South Sandwich Islands
                      </option>
                      <option value="SHN">
                        Saint Helena, Ascension and Tristan da Cunha
                      </option>
                      <option value="SJM">Svalbard and Jan Mayen</option>
                      <option value="SLB">Solomon Islands</option>
                      <option value="SLE">Sierra Leone</option>
                      <option value="SLV">El Salvador</option>
                      <option value="SMR">San Marino</option>
                      <option value="SOM">Somalia</option>
                      <option value="SPM">Saint Pierre and Miquelon</option>
                      <option value="SRB">Serbia</option>
                      <option value="SSD">South Sudan</option>
                      <option value="STP">Sao Tome and Principe</option>
                      <option value="SUR">Suriname</option>
                      <option value="SVK">Slovakia</option>
                      <option value="SVN">Slovenia</option>
                      <option value="SWE">Sweden</option>
                      <option value="SWZ">Eswatini</option>
                      <option value="SXM">Sint Maarten (Dutch part)</option>
                      <option value="SYC">Seychelles</option>
                      <option value="SYR">Syrian Arab Republic (the)</option>
                      <option value="TCA">
                        Turks and Caicos Islands (the)
                      </option>
                      <option value="TCD">Chad</option>
                      <option value="TGO">Togo</option>
                      <option value="THA">Thailand</option>
                      <option value="TJK">Tajikistan</option>
                      <option value="TKL">Tokelau</option>
                      <option value="TKM">Turkmenistan</option>
                      <option value="TLS">Timor-Leste</option>
                      <option value="TON">Tonga</option>
                      <option value="TTO">Trinidad and Tobago</option>
                      <option value="TUN">Tunisia</option>
                      <option value="TUR">Türkiye</option>
                      <option value="TUV">Tuvalu</option>
                      <option value="TWN">Taiwan (Province of China)</option>
                      <option value="TZA">
                        Tanzania, the United Republic of
                      </option>
                      <option value="UGA">Uganda</option>
                      <option value="UKR">Ukraine</option>
                      <option value="UMI">
                        United States Minor Outlying Islands (the)
                      </option>
                      <option value="URY">Uruguay</option>
                      {countryCode !== "IN" ? (
                        <option value="USA" selected="selected">
                          United States of America (the)
                        </option>
                      ) : (
                        <option value="USA">
                          United States of America (the)
                        </option>
                      )}
                      <option value="UZB">Uzbekistan</option>
                      <option value="VAT">Holy See (the)</option>
                      <option value="VCT">
                        Saint Vincent and the Grenadines
                      </option>
                      <option value="VEN">
                        Venezuela (Bolivarian Republic of)
                      </option>
                      <option value="VGB">Virgin Islands (British)</option>
                      <option value="VIR">Virgin Islands (U.S.)</option>
                      <option value="VNM">Viet Nam</option>
                      <option value="VUT">Vanuatu</option>
                      <option value="WLF">Wallis and Futuna</option>
                      <option value="WSM">Samoa</option>
                      <option value="YEM">Yemen</option>
                      <option value="ZAF">South Africa</option>
                      <option value="ZMB">Zambia</option>
                      <option value="ZWE">Zimbabwe</option>
                    </FieldGroup>
                  </div>
                </div>

                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div style={{ width: "37.5%" }}>
                    <FieldGroup
                      type="text"
                      label="Subscriber's Full Name:"
                      value={subData.sub_user_name}
                      name="sub_user_name"
                      id="sub_user_name"
                      required="required"
                      onChange={handlesubDataChange}
                      // readOnly = {subEdit?"readonly":""}
                    ></FieldGroup>
                  </div>
                  <div style={{ marginLeft: "10px", width: "37.5%" }}>
                    <FieldGroup
                      type="text"
                      label="Subscriber's Title:"
                      value={subData.sub_user_title}
                      name="sub_user_title"
                      id="sub_user_title"
                      required="required"
                      onChange={handlesubDataChange}
                      // readOnly = {subEdit?"readonly":""}
                    ></FieldGroup>
                  </div>
                  <div style={{ marginLeft: "10px", width: "23%" }}>
                    <FieldGroup
                      type="text"
                      label="Subscriber's Phone:"
                      value={subData.sub_user_ph}
                      name="sub_user_ph"
                      id="sub_user_ph"
                      required="required"
                      onChange={handlesubDataChange}
                      // readOnly = {subEdit?"readonly":""}
                    ></FieldGroup>
                  </div>
                </div>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div style={{ witdh: "35%" }}>
                    <FieldGroup
                      componentClass="select"
                      label="Subscription Type:"
                      value={subData.sub_type}
                      name="sub_type"
                      id="sub_type"
                      required="required"
                      onChange={handlesubDataChange}
                      disabled={subEdit && sub_count != 0}
                    >
                      <option value="NOAUDIO">
                        Non-Audio School Picture Products
                      </option>
                      <option value="AUDIO">
                        Audio School Picture Products
                      </option>
                    </FieldGroup>
                  </div>
                  <div style={{ marginLeft: "20px", witdh: "20%" }}>
                    <FieldGroup
                      type="number"
                      label="Subscription Count:"
                      value={subData.sub_count}
                      name="sub_count"
                      id="sub_count"
                      readOnly
                    ></FieldGroup>
                  </div>
                  <div style={{ marginLeft: "20px", witdh: "15%" }}>
                    <FieldGroup
                      type="text"
                      label="Start Date:"
                      value={subData.sub_start_date}
                      name="sub_start_date"
                      id="sub_start_date"
                      readOnly
                    ></FieldGroup>
                  </div>
                  <div style={{ marginLeft: "20px", witdh: "15%" }}>
                    <FieldGroup
                      type="text"
                      label="End Date:"
                      value={subData.sub_end_date}
                      name="sub_end_date"
                      id="sub_end_date"
                      readOnly
                    ></FieldGroup>
                  </div>
                  <div style={{ marginLeft: "20px", width: "16%" }}>
                    <FieldGroup
                      type="text"
                      label="Allocated Space (GB):"
                      value={subData.total_space}
                      name="total_space"
                      id="total_space"
                      readOnly
                    ></FieldGroup>
                  </div>
                  <div style={{ marginLeft: "20px", width: "15%" }}>
                    <FieldGroup
                      type="text"
                      label="Available Space (GB):"
                      value={subData.avail_space}
                      name="avail_space"
                      id="avail_space"
                      readOnly
                    ></FieldGroup>
                  </div>
                </div>
              </div>
              <br></br>

              <div id="mySpinner" style={{ display: "none", zIndex: "9999" }}>
                <SPLoader></SPLoader>
              </div>
            </Modal.Body>

            <Modal.Footer>
              <Button
                type="submit"
                style={{
                  backgroundColor: "blue",
                  borderRadius: "25%",
                  color: "white"
                }}
              >
                Submit
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>

        <Modal
          show={subRenew}
          dialogClassName="modal-90w"
          centered="true"
          onHide={() => {
            setsubRenew(false);
          }}
          style={{ marginTop: "45px" }}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Renew Subscription - Status
              {subData.status !== "ACTIVE" ? (
                subData.status !== "EXPIRED" ? (
                  <span style={{ color: "red" }}> - Pending Payment</span>
                ) : (
                  <span style={{ color: "red" }}>
                    {" "}
                    - Expired - Renew Immediately
                  </span>
                )
              ) : (
                <span style={{ color: "green" }}> - Active</span>
              )}
            </Modal.Title>
          </Modal.Header>

          <Form onSubmit={handleSubRenew} className="override_form">
            <Modal.Body>
              <br></br>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div style={{ width: "76%" }}>
                    <FieldGroup
                      type="text"
                      label="Educational Institution Name:"
                      value={subData.edu_inst_name}
                      name="edu_inst_name"
                      id="edu_inst_name"
                      required="required"
                      onChange={handlesubDataChange}
                      readOnly
                    ></FieldGroup>
                  </div>
                  <div style={{ marginLeft: "10px", width: "23%" }}>
                    <FieldGroup
                      type="text"
                      label="Educational Institution Phone:"
                      value={subData.edu_inst_ph}
                      name="edu_inst_ph"
                      id="edu_inst_ph"
                      required="required"
                      onChange={handlesubDataChange}
                      readOnly
                    ></FieldGroup>
                  </div>
                </div>

                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div style={{ width: "33%" }}>
                    <FieldGroup
                      type="text"
                      label="Educational Institution Address Line1:"
                      value={subData.addr_line1}
                      name="addr_line1"
                      id="addr_line1"
                      required="required"
                      onChange={handlesubDataChange}
                      readOnly
                    ></FieldGroup>
                  </div>
                  <div style={{ marginLeft: "10px", width: "33%" }}>
                    <FieldGroup
                      type="text"
                      label="Educational Institution Address Line2:"
                      value={subData.addr_line2}
                      name="addr_line2"
                      id="addr_line2"
                      required="required"
                      onChange={handlesubDataChange}
                      readOnly
                    ></FieldGroup>
                  </div>
                  <div style={{ marginLeft: "10px", width: "32.5%" }}>
                    <FieldGroup
                      type="text"
                      label="Educational Institution Address Line3:"
                      value={subData.addr_line3}
                      name="addr_line3"
                      id="addr_line3"
                      // required="required"
                      onChange={handlesubDataChange}
                      readOnly
                    ></FieldGroup>
                  </div>
                </div>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div style={{ width: "23.7%" }}>
                    <FieldGroup
                      type="text"
                      label="City:"
                      value={subData.city}
                      name="city"
                      id="city"
                      required="required"
                      onChange={handlesubDataChange}
                      readOnly
                    ></FieldGroup>
                  </div>
                  <div style={{ marginLeft: "10px", width: "23%" }}>
                    <FieldGroup
                      type="text"
                      label="State"
                      value={subData.state}
                      name="state"
                      id="state"
                      required="required"
                      onChange={handlesubDataChange}
                      readOnly
                    ></FieldGroup>
                  </div>
                  <div style={{ marginLeft: "10px", width: "18%" }}>
                    <FieldGroup
                      type="text"
                      label="PIN/ZIP Code:"
                      value={subData.zip}
                      name="zip"
                      id="zip"
                      required="required"
                      onChange={handlesubDataChange}
                      readOnly
                    ></FieldGroup>
                  </div>
                  <div style={{ marginLeft: "10px", width: "33%" }}>
                    <FieldGroup
                      type="text"
                      label="Country:"
                      value={subData.country_code}
                      name="country_code"
                      id="country_code"
                      required="required"
                      onChange={handlesubDataChange}
                      readOnly
                    ></FieldGroup>
                  </div>
                </div>

                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div style={{ width: "37.5%" }}>
                    <FieldGroup
                      type="text"
                      label="Subscriber's Full Name:"
                      value={subData.sub_user_name}
                      name="sub_user_name"
                      id="sub_user_name"
                      required="required"
                      onChange={handlesubDataChange}
                      readOnly
                    ></FieldGroup>
                  </div>
                  <div style={{ marginLeft: "10px", width: "37.5%" }}>
                    <FieldGroup
                      type="text"
                      label="Subscriber's Title:"
                      value={subData.sub_user_title}
                      name="sub_user_title"
                      id="sub_user_title"
                      required="required"
                      onChange={handlesubDataChange}
                      readOnly
                    ></FieldGroup>
                  </div>
                  <div style={{ marginLeft: "10px", width: "23%" }}>
                    <FieldGroup
                      type="text"
                      label="Subscriber's Phone:"
                      value={subData.sub_user_ph}
                      name="sub_user_ph"
                      id="sub_user_ph"
                      required="required"
                      onChange={handlesubDataChange}
                      readOnly
                    ></FieldGroup>
                  </div>
                </div>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div style={{ witdh: "35%" }}>
                    <FieldGroup
                      componentClass="select"
                      label="Subscription Type:"
                      value={subData.sub_type}
                      name="sub_type"
                      id="sub_type"
                      required="required"
                      onChange={handlesubDataChange}
                      disabled={true}
                    >
                      <option value="NOAUDIO">
                        Non-Audio School Picture Products
                      </option>
                      <option value="AUDIO">
                        Audio School Picture Products
                      </option>
                    </FieldGroup>
                  </div>
                  <div style={{ marginLeft: "20px", witdh: "20%" }}>
                    <FieldGroup
                      type="number"
                      label="Subscription Count:"
                      value={subData.sub_count}
                      name="sub_count"
                      id="sub_count"
                      readOnly
                    ></FieldGroup>
                  </div>
                  <div style={{ marginLeft: "20px", witdh: "15%" }}>
                    <FieldGroup
                      type="text"
                      label="Start Date:"
                      value={subData.sub_start_date}
                      name="sub_start_date"
                      id="sub_start_date"
                      readOnly
                    ></FieldGroup>
                  </div>
                  <div style={{ marginLeft: "20px", witdh: "15%" }}>
                    <FieldGroup
                      type="text"
                      label="End Date:"
                      value={subData.sub_end_date}
                      name="sub_end_date"
                      id="sub_end_date"
                      readOnly
                    ></FieldGroup>
                  </div>
                  <div style={{ marginLeft: "20px", width: "16%" }}>
                    <FieldGroup
                      type="text"
                      label="Allocated Space (GB):"
                      value={subData.total_space}
                      name="total_space"
                      id="total_space"
                      readOnly
                    ></FieldGroup>
                  </div>
                  <div style={{ marginLeft: "20px", width: "15%" }}>
                    <FieldGroup
                      type="text"
                      label="Available Space (GB):"
                      value={subData.avail_space}
                      name="avail_space"
                      id="avail_space"
                      readOnly
                    ></FieldGroup>
                  </div>
                </div>
              </div>
              <br></br>

              <div id="mySpinner" style={{ display: "none", zIndex: "9999" }}>
                <SPLoader></SPLoader>
              </div>

              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  style={{
                    backgroundColor: "green",
                    color: "white",
                    fontSize: "20px"
                  }}
                  onClick={manageSpace}
                >
                  Manage Space
                </Button>
                <Button
                  style={{
                    backgroundColor: "green",
                    color: "white",
                    fontSize: "20px",
                    marginLeft: "20px"
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (subData.renewalCount > 0) {
                      alert(
                        `Subscription already paid & Renewed for ${subData.renewalUserCount} students\nSubscription will be renewed on the last day of current Subscription`
                      );
                      return false;
                    }
                    setSubType(sub_type);
                    setSubPrice(price);
                    setsubCount(sub_count);
                    setpaymentRenewal(true);
                    setpayingSub(true);
                  }}
                >
                  Renew Subscription (Users)
                </Button>

                <Button
                  style={{
                    backgroundColor: "green",
                    color: "white",
                    fontSize: "20px",
                    marginLeft: "20px"
                  }}
                  onClick={(e) => {
                    getSubRenewalDetails();

                    if (subData.renewalUserCount < 1) {
                      alert(
                        `Renew Subscription (Users) first before renewing space`
                      );
                      return false;
                    }
                    if (subData.renewalSpace > 0) {
                      alert(
                        `Space has been already paid & Renewed for ${subData.renewalSpace} Gigabytes\nSpace will be renewed on the last day of current Subscription`
                      );
                      return false;
                    }
                    setrenewSpace(true);
                  }}
                >
                  Renew Space
                </Button>
              </div>
            </Modal.Body>

            <Modal.Footer></Modal.Footer>
          </Form>
        </Modal>

        {countryCode !== "IN" ? (
          <PaymentModal
            fields={fieldsData}
            resetStorage={() => {
              setfieldsData({
                ...fieldsData,
                no_of_gb: 0
              });
            }}
            renewal_flg={true}
          />
        ) : (
          <RPPaymentModal
            fields={fieldsData}
            resetStorage={() => {
              setfieldsData({
                ...fieldsData,
                no_of_gb: 0
              });
            }}
            renewal_flg={true}
          />
        )}

        <Modal
          // dialogClassName="modal-90w"
          centered
          show={agreeSub}
          onHide={() => {
            setagreeSub(false);
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Subscription - Terms & Conditions</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <br></br>
            <h3 style={{ textAlign: "center" }}>
              Read the Terms & Conditions carefully
            </h3>
            <ul
              style={{
                marginLeft: "-10px",
                color: "green",
                fontFamily: "salsa"
              }}
            >
              {countryCode !== "IN" ? (
                <Fragment>
                  <li>
                    You confirm that you are purchasing Subscription for your
                    Educational Institution which is properly registered and
                    approved for operation in the country which you operate. If
                    your entity/institution in not an educational institution as
                    deemed by Composz, it will lead to immediate SUSPENSION of
                    your account and that you agree to forego any amount you
                    already paid and that you are not entitled to any REFUND.
                    All decisions made by Composz are final. Also you will not
                    hold Composz LLC liable for any loss arising due to the
                    suspension or loss of amount already paid and further you
                    agree that you will not take any legal action towards
                    Composz LLC regarding this. If you are not an Educational
                    institution, DO NOT pucrhase Subscription.
                  </li>
                  <li style={{ marginTop: "10px" }}>
                    You agree to provide honest and accurate details regarding
                    your Institution/School details including accurate students
                    count.
                  </li>
                  <li style={{ marginTop: "10px" }}>
                    You understand and agree that there is no REFUND once
                    payment is made towards purchase of Subscription or purchase
                    of storage spaces in composz.com.
                  </li>
                  <li style={{ marginTop: "10px" }}>
                    You understand and agree that all details provided by you
                    are accurate and any inaccurate details will lead to
                    immediate SUSPENSION of your account and that you agree to
                    forego any amount you already paid and that you are not
                    entitled to any REFUND. Also you will not hold Composz LLC
                    liable for any loss arising due to the suspension or loss of
                    amount already paid and further you agree that you will not
                    take any legal action towards Composz LLC regarding this.
                  </li>
                  <li style={{ marginTop: "10px" }}>
                    You understand and agree that you will only and only use
                    composz.com for the intended institution/School for which
                    the SUBSCRIPTION is paid for. For example if you have 2
                    schools under your institution with 1000 students each, and
                    you have purchased SUBSCRIPTION for only one school for a
                    total student count of 1000. You are only allowed to use
                    composz.com to generate school pictures for that one
                    intended school only. You cannot use composz.com to service
                    500 students for one school and another 500 students for the
                    second school. This will be considered a violation of Terms
                    & Conditions and will lead to immediate SUSPENSION of your
                    account and that you agree to forego any amount you already
                    paid and that you are not entitled to any REFUND. Also you
                    will not hold Composz LLC liable for any loss arising due to
                    the suspension or loss of amount already paid and further
                    you agree that you will not take any legal action towards
                    Composz LLC regarding this. In such scenario, you should
                    purchase 2 separate subscription for each school with
                    student count of 500 each.
                  </li>
                  <li style={{ marginTop: "10px" }}>
                    You agree and understand that you have to purchase
                    Subscription (student count) for the whole or entire number
                    of students in your individual school even if you intend to
                    use composz.com for only partial number of students. If you
                    want to use composz.com only for partial number of students,
                    do not purchase subscription. Plan to use composz.com as a
                    non-subscription user. Partial student count purchase for
                    your school will be considered as a violation and will lead
                    to immediate SUSPENSION of your account and that you agree
                    to forego any amount you already paid and that you are not
                    entitled to any REFUND. Also you will not hold Composz LLC
                    liable for any loss arising due to the suspension or loss of
                    amount already paid and further you agree that you will not
                    take any legal action towards Composz LLC regarding this.
                  </li>
                  <li style={{ marginTop: "10px" }}>
                    You agree to use composz.com only and only for the number of
                    students count that you purchased the SUBSCRIPTION for. Any
                    usage of composz.com beyond that purchased students count
                    will be considered as a violation and will lead to immediate
                    SUSPENSION of your account and that you agree to forego any
                    amount you already paid and that you are not entitled to any
                    REFUND. Also you will not hold Composz LLC liable for any
                    loss arising due to the suspension or loss of amount already
                    paid and further you agree that you will not take any legal
                    action towards Composz LLC regarding this.
                  </li>
                  <li style={{ marginTop: "10px" }}>
                    You agree to promptly purchase SUBSCRIPTION for additional
                    students if the student count increases in that subscription
                    year. Noncompliance will be treated as a violation and will
                    lead to immediate SUSPENSION of your account and that you
                    agree to forego any amount you already paid and that you are
                    not entitled to any REFUND. Also you will not hold Composz
                    LLC liable for any loss arising due to the suspension or
                    loss of amount already paid and further you agree that you
                    will not take any legal action towards Composz LLC regarding
                    this. Please note, LIFE COLORS will not REFUND you for any
                    decrease in student count in that subscription year after
                    payment is made.
                  </li>
                  <li style={{ marginTop: "10px" }}>
                    You agree and understand that storage space allocated or
                    purchased will reduce in size based on your activities like
                    but not limited to Product Creation, Uploading of images and
                    data, Generation of Product Files, etc. You also understand
                    that composz.com also generates additional files to support
                    your activities and that in turn will also reduce your
                    allocated or purchased space. It is your duty to manage
                    space. Space details are available in 'File Manager'.
                    Usually you can reclaim space by 'Unfreezing Products' after
                    'Download' which will delete generated files from
                    composz.com, or by deleting Products. If you need additional
                    space, you can purchase so at your own discretion. Space
                    purchased will always be for the reminder of Subscription
                    months.
                  </li>
                  <li style={{ marginTop: "10px" }}>
                    You agree and understand that Composz LLC will actively
                    monitor your usage of composz.com for any violation by
                    accessing any and all products and their contents that you
                    create and generate files for.
                  </li>
                  <li style={{ marginTop: "10px" }}>
                    You agree and understand in an unfortunate event of your
                    account suspension sincerely not due to any of your
                    violations, any such remedies for any SUSPENSIONS not due to
                    the violations will be handled online only via email
                    communications and it may take time to resolve. But rest
                    assured Composz LLC is committed to attending to such
                    unfortunate scenarios immediately.
                  </li>
                </Fragment>
              ) : (
                <Fragment>
                  <li>
                    You confirm that you are purchasing Subscription for your
                    Educational Institution which is properly registered and
                    approved for operation in the country which you operate. If
                    your entity/institution in not an educational institution as
                    deemed by Composz, it will lead to immediate SUSPENSION of
                    your account and that you agree to forego any amount you
                    already paid and that you are not entitled to any REFUND.
                    All decisions made by Composz are final. Also you will not
                    hold LIFE COLORS liable for any loss arising due to the
                    suspension or loss of amount already paid and further you
                    agree that you will not take any legal action towards LIFE
                    COLORS regarding this. If you are not an Educational
                    institution, DO NOT pucrhase Subscription.
                  </li>
                  <li style={{ marginTop: "10px" }}>
                    You agree to provide honest and accurate details regarding
                    your Institution/School details including accurate students
                    count.
                  </li>
                  <li style={{ marginTop: "10px" }}>
                    You understand and agree that there is no REFUND once
                    payment is made towards purchase of Subscription or purchase
                    of storage spaces in composz.com.
                  </li>
                  <li style={{ marginTop: "10px" }}>
                    You understand and agree that all details provided by you
                    are accurate and any inaccurate details will lead to
                    immediate SUSPENSION of your account and that you agree to
                    forego any amount you already paid and that you are not
                    entitled to any REFUND. Also you will not hold LIFE COLORS
                    liable for any loss arising due to the suspension or loss of
                    amount already paid and further you agree that you will not
                    take any legal action towards LIFE COLORS regarding this.
                  </li>
                  <li style={{ marginTop: "10px" }}>
                    You understand and agree that you will only and only use
                    composz.com for the intended institution/School for which
                    the SUBSCRIPTION is paid for. For example if you have 2
                    schools under your institution with 1000 students each, and
                    you have purchased SUBSCRIPTION for only one school for a
                    total student count of 1000. You are only allowed to use
                    composz.com to generate school pictures for that one
                    intended school only. You cannot use composz.com to service
                    500 students for one school and another 500 students for the
                    second school. This will be considered a violation of Terms
                    & Conditions and will lead to immediate SUSPENSION of your
                    account and that you agree to forego any amount you already
                    paid and that you are not entitled to any REFUND. Also you
                    will not hold LIFE COLORS liable for any loss arising due to
                    the suspension or loss of amount already paid and further
                    you agree that you will not take any legal action towards
                    LIFE COLORS regarding this. In such scenario, you should
                    purchase 2 separate subscription for each school with
                    student count of 500 each.
                  </li>
                  <li style={{ marginTop: "10px" }}>
                    You agree and understand that you have to purchase
                    Subscription (student count) for the whole or entire number
                    of students in your individual school even if you intend to
                    use composz.com for only partial number of students. If you
                    want to use composz.com only for partial number of students,
                    do not purchase subscription. Plan to use composz.com as a
                    non-subscription user. Partial student count purchase for
                    your school will be considered as a violation and will lead
                    to immediate SUSPENSION of your account and that you agree
                    to forego any amount you already paid and that you are not
                    entitled to any REFUND. Also you will not hold LIFE COLORS
                    liable for any loss arising due to the suspension or loss of
                    amount already paid and further you agree that you will not
                    take any legal action towards LIFE COLORS regarding this.
                  </li>
                  <li style={{ marginTop: "10px" }}>
                    You agree to use composz.com only and only for the number of
                    students count that you purchased the SUBSCRIPTION for. Any
                    usage of composz.com beyond that purchased students count
                    will be considered as a violation and will lead to immediate
                    SUSPENSION of your account and that you agree to forego any
                    amount you already paid and that you are not entitled to any
                    REFUND. Also you will not hold LIFE COLORS liable for any
                    loss arising due to the suspension or loss of amount already
                    paid and further you agree that you will not take any legal
                    action towards LIFE COLORS regarding this.
                  </li>
                  <li style={{ marginTop: "10px" }}>
                    You agree to promptly purchase SUBSCRIPTION for additional
                    students if the student count increases in that subscription
                    year. Noncompliance will be treated as a violation and will
                    lead to immediate SUSPENSION of your account and that you
                    agree to forego any amount you already paid and that you are
                    not entitled to any REFUND. Also you will not hold LIFE
                    COLORS liable for any loss arising due to the suspension or
                    loss of amount already paid and further you agree that you
                    will not take any legal action towards LIFE COLORS regarding
                    this. Please note, LIFE COLORS will not REFUND you for any
                    decrease in student count in that subscription year after
                    payment is made.
                  </li>
                  <li style={{ marginTop: "10px" }}>
                    You agree and understand that storage space allocated or
                    purchased will reduce in size based on your activities like
                    but not limited to Product Creation, Uploading of images and
                    data, Generation of Product Files, etc. You also understand
                    that composz.com also generates additional files to support
                    your activities and that in turn will also reduce your
                    allocated or purchased space. It is your duty to manage
                    space. Space details are available in 'File Manager'.
                    Usually you can reclaim space by 'Unfreezing Products' after
                    'Download' which will delete generated files from
                    composz.com, or by deleting Products. If you need additional
                    space, you can purchase so at your own discretion. Space
                    purchased will always be for the reminder of Subscription
                    months.
                  </li>
                  <li style={{ marginTop: "10px" }}>
                    You agree and understand that LIFE COLORS will actively
                    monitor your usage of composz.com for any violation by
                    accessing any and all products and their contents that you
                    create and generate files for.
                  </li>
                  <li style={{ marginTop: "10px" }}>
                    You agree and understand in an unfortunate event of your
                    account suspension sincerely not due to any of your
                    violations, any such remedies for any SUSPENSIONS not due to
                    the violations will be handled online only via email
                    communications and it may take time to resolve. But rest
                    assured LIFE COLORS is committed to attending to such
                    unfortunate scenarios immediately.
                  </li>
                </Fragment>
              )}
            </ul>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginLeft: "20px"
              }}
            >
              <h5
                style={{
                  marginLeft: "10px",
                  marginRight: "10px",
                  marginTop: "10px"
                }}
              >
                I understand and Agree to the mentioned Terms & Conditions:
              </h5>
              <FieldGroup
                id="formControlIsPreset"
                type="checkbox"
                label=""
                name="agree"
                placeholder="agree"
                onChange={(e) => {
                  setAgreedSub(e.target.checked);
                }}
                className="override_checkbox"
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              style={{
                backgroundColor: "green",
                color: "white",
                fontSize: "20px",
                marginLeft: "15px",
                marginTop: "15px"
              }}
              onClick={(e) => {
                if (AgreedSub) {
                  setagreeSub(false);
                  handleSubCreate();
                } else {
                  alert(
                    "You have to Agree before proceeding.\nIf you do not agree simply close this window to exit 'Subscription' purchase."
                  );
                }
              }}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          dialogClassName="modal-90w"
          centered
          show={renewSpace}
          onHide={() => {
            setrenewSpace(false);
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Purchase Storage for post Renewal</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <br></br>
            <h4>
              {" "}
              Your current occupied space is{" "}
              {subData.total_space - subData.avail_space} Gigabytes
            </h4>
            <h4>
              {" "}
              Post renewal your default alloted space is{" "}
              {subData.sub_type !== "AUDIO" ? 2.0 : 5.0} Gigabytes at no extra
              cost
            </h4>
            <h4>
              {" "}
              Recommendation: DO NOT Renew Space if alloted space is more than
              occupied space
            </h4>
            <br></br>
            <div className="flex_align">
              <FieldGroup
                id="formControlPages"
                type="number"
                label="Number of Giga Bytes"
                name="no_of_gb"
                min="1"
                max="10"
                placeholder="Number of GB"
                required="required"
                onChange={({ target: { name, value } }) => {
                  if (value < 1 || value > 10) {
                    alert("Number of Giga Bytes has to be within 1 and 10");
                    setGigabyte(1);
                  } else setGigabyte(parseInt(value));
                }}
                onBlur={({ target: { name, value } }) => {
                  if (value < 1 || value > 10) {
                    alert("Number of Giga Bytes has to be within 1 and 10");
                    setGigabyte(1);
                  }
                }}
                // value={this.state.no_of_gb ? this.state.no_of_gb : 0}
                value={Gigabyte}
              />

              <Button
                style={{
                  backgroundColor: "green",
                  color: "white",
                  fontSize: "20px",
                  marginLeft: "15px",
                  marginTop: "15px"
                }}
                onClick={(e) => {
                  if (Gigabyte < 1) {
                    alert(
                      "Number of Giga Bytes value should be greater than 0. Please enter valid value"
                    );
                    setGigabyte(1);
                    return false;
                  } else {
                    setfieldsData({
                      ...fieldsData,
                      no_of_gb: Gigabyte,
                      storage_unit: "GIGA_BYTE",
                      subscription_id: sub_id,
                      subscription_status: subscription_status,
                      sub_start_date: subData.sub_start_date,
                      sub_end_date: subData.sub_end_date
                    });
                    setrenewSpace(false);
                    setsubRenew(false);
                  }
                }}
              >
                Proceed to Payment
              </Button>

              <br></br>
              <strong style={{ marginLeft: "15px", marginTop: "20px" }}>
                Price for 1GB: {countryCode !== "IN" ? "$1.00" : " ₹81.00"}
              </strong>
              {sub_id !== 0 ? (
                <strong style={{ marginLeft: "15px", marginTop: "20px" }}>
                  {" "}
                  per month and multiplied by 12 months for the next
                  Subscription Year
                </strong>
              ) : (
                ""
              )}
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={payingSub}
          onHide={() => {
            setpayingSub(false);
            if (paymentRenewal) setpaymentRenewal(false);
            window.location.reload();
          }}
          style={{ marginTop: "45px" }}
        >
          <Modal.Header closeButton>
            {paymentRenewal ? (
              <Modal.Title>Subscription Renewal Payment</Modal.Title>
            ) : (
              <Modal.Title>Subscription Payment</Modal.Title>
            )}
          </Modal.Header>
          <h3 style={{ marginTop: "15px", marginLeft: "15px" }}>Note:</h3>
          <p
            style={{
              marginTop: "-20px",
              marginLeft: "15px",
              fontSize: "15px",
              fontWeight: "bold"
            }}
          >
            <br></br>- Price per Student is{" "}
            {SubType !== "AUDIO"
              ? countryCode !== "IN"
                ? "$1.00"
                : "₹50.00"
              : countryCode !== "IN"
              ? "$2.00"
              : "₹100.00"}
            <br></br>
            <br></br>- Please choose your whole school student strength as
            Number of Students
            <br></br>
            <br></br>- minimum number of Students count is 200
            <br></br>
            <br></br>- if paying for additional Students, minimum count is 1
            <br></br>
            <br></br>- if paying for Renewal, minimum count is 200
            <br></br>
          </p>

          <Form onSubmit={""} className="override_form">
            <Modal.Body>
              <FieldGroup
                type="number"
                id="sub_count"
                label="Enter Number of Students"
                name="subCount"
                placeholder="Minimum: 200"
                //min="200"
                //max="4000"
                required="required"
                defaultValue={subCount}
                value={subCount}
                onChange={({ target: { name, value } }) => {
                  setsubCount(value);
                }}
                onBlur={({ target: { name, value } }) => {
                  if (!additionalUsers || paymentRenewal) {
                    if (value < 200 || value > 4000) {
                      alert("Students count has to be within 200 and 4000");
                      setsubCount(200);
                    }
                  } else {
                    if (value <= 0 || value > 4000 - sub_count) {
                      alert(
                        `Students count has to be within 1 and ${
                          4000 - sub_count
                        }`
                      );
                      setsubCount(1);
                    }
                  }
                }}
              ></FieldGroup>

              <Button
                style={{
                  backgroundColor: "green",
                  color: "white",
                  fontSize: "20px",
                  marginBottom: "10px",
                  marginTop: "5px"
                }}
                onClick={() => {
                  if (
                    (!additionalUsers || paymentRenewal) &&
                    (subCount < 200 || subCount > 4000)
                  ) {
                    alert(
                      "Students count has to be within 200 and 4000. Please enter valid value"
                    );
                    setsubCount(200);
                    return false;
                  } else {
                    setpayingSub(false);
                    setpaymentModal(true);
                  }
                }}
              >
                Proceed to Payment
              </Button>
            </Modal.Body>

            <Modal.Footer>
              {/* <Button type = "submit" style={{ backgroundColor: "blue", borderRadius: '25%', color: "white"}}  >
                    Submit
                  </Button> */}
            </Modal.Footer>
          </Form>
        </Modal>

        <Modal
          centered="true"
          show={paymentModal}
          onHide={() => {
            setpaymentModal(false);
            if (paymentRenewal) setpaymentRenewal(false);
          }}
        >
          <Modal.Header closeButton>
            {paymentRenewal ? (
              <Modal.Title>Renew Subscription (Users)</Modal.Title>
            ) : (
              <Modal.Title>Purchase Subscription</Modal.Title>
            )}
          </Modal.Header>
          <Modal.Body>
            <ul style={{ listStyleType: "none" }}>
              {countryCode !== "IN" ? (
                <Fragment>
                  <li>
                    <strong>
                      Total Price for {subCount} Students:{" "}
                      {formatCurrency(subCount * SubPrice, 1, "USD")}
                    </strong>
                  </li>
                  <li>
                    <strong>
                      Convenience Charges (5%): $
                      {parseFloat(
                        subCount * SubPrice * convenienceCharges
                      ).toFixed(2)}
                    </strong>
                  </li>
                  <li>
                    <strong>TAX : $0.0</strong>
                  </li>
                  <li>
                    <strong>
                      Grand Total: ${" "}
                      {(
                        subCount * SubPrice +
                        subCount * SubPrice * convenienceCharges
                      ).toFixed(2)}
                    </strong>
                  </li>
                </Fragment>
              ) : (
                <Fragment>
                  <li>
                    <strong>
                      Total Price for {subCount} Students:{" "}
                      {formatCurrency(subCount * SubPrice, 1, "INR")}
                    </strong>
                  </li>
                  <li>
                    <strong>
                      Convenience Charges : ₹
                      {parseFloat(
                        subCount * SubPrice * convenienceCharges
                      ).toFixed(2)}
                    </strong>
                  </li>
                  <li>
                    <strong>
                      GST 18% : ₹
                      {parseFloat(
                        (subCount * SubPrice +
                          subCount * SubPrice * convenienceCharges) *
                          gst
                      ).toFixed(2)}
                    </strong>
                  </li>
                  <li>
                    <strong>
                      Grand Total (rounded): ₹{" "}
                      {Math.round(
                        subCount * SubPrice +
                          subCount * SubPrice * convenienceCharges +
                          (subCount * SubPrice +
                            subCount * SubPrice * convenienceCharges) *
                            gst
                      ).toFixed(2)}
                    </strong>
                  </li>
                </Fragment>
              )}
            </ul>
            {countryCode !== "IN" ? (
              <Fragment>
                <SubscriptionPayment
                  sub_id={isNaN(SubID) ? sub_id : SubID}
                  price={SubPrice}
                  sub_count={subCount}
                  amount={(
                    subCount * SubPrice +
                    subCount * SubPrice * convenienceCharges
                  ).toFixed(2)}
                  additional_users_flg={additionalUsers}
                  renewal_flg={paymentRenewal}
                  subscription_status={subscription_status}
                />
              </Fragment>
            ) : (
              <Fragment>
                <RPSubscriptionPayment
                  sub_id={isNaN(SubID) ? sub_id : SubID}
                  price={SubPrice}
                  sub_count={subCount}
                  amount={Math.round(
                    subCount * SubPrice +
                      subCount * SubPrice * convenienceCharges +
                      (subCount * SubPrice +
                        subCount * SubPrice * convenienceCharges) *
                        gst
                  ).toFixed(2)}
                  additional_users_flg={additionalUsers}
                  renewal_flg={paymentRenewal}
                />
              </Fragment>
            )}
          </Modal.Body>
        </Modal>

        <Modal
          id="Invoices"
          dialogClassName="modal-90w"
          centered="true"
          show={isFileManagerOpen}
          onHide={openFileManager}
        >
          <Modal.Header closeButton>
            <Modal.Title>Subscription Purchases</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {purchaseHistory && purchaseHistory.length > 0 && (
              <Row>
                <Col md={12}>
                  <table className="table table-bordered">
                    <caption className="sub_history">
                      Purchase Subscription - History
                    </caption>
                    <thead>
                      <tr>
                        <th scope="col">Subscription ID</th>
                        <th scope="col">No of Students</th>
                        {mobile ? (
                          ""
                        ) : (
                          <Fragment>
                            <th scope="col">Purchased On</th>
                            <th scope="col">Payment ID</th>
                          </Fragment>
                        )}
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {purchaseHistory &&
                        purchaseHistory.map((sub) => {
                          return (
                            <tr>
                              <td>{sub.subscription_id}</td>
                              <td>{sub.sub_count}</td>
                              {mobile ? (
                                ""
                              ) : (
                                <Fragment>
                                  <td>{`${new Date(
                                    sub.purchased_on
                                  ).toLocaleString()}`}</td>
                                  {countryCode !== "IN" ? (
                                    <td>{sub.pg_reference_id}</td>
                                  ) : (
                                    <td>{sub.razorpay_capture.id}</td>
                                  )}
                                </Fragment>
                              )}
                              <td>
                                <Button
                                  className="btnsmall btn-success"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    setcurrentOrder(sub);
                                    setisEditProductClicked(true);
                                  }}
                                >
                                  Show Invoice
                                </Button>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </Col>
              </Row>
            )}
          </Modal.Body>
        </Modal>
        {isEditProductClicked &&
          (countryCode !== "IN"
            ? getOrderInvoice(currentOrder)
            : getrazorpayOrderInvoice(currentOrder))}

        <Modal
          centered="true"
          dialogClassName="modal-90w"
          show={spaceModal}
          onHide={() => {
            setspaceModal(false);
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Manage Space</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {subFolders && subFolders.length > 0 && (
              <Row>
                <Col md={12}>
                  <table className="table table-bordered">
                    <caption className="sub_folders">
                      Subscription Users - Product & Space details
                    </caption>
                    <thead>
                      <tr>
                        <th scope="col">User Name</th>
                        <th scope="col">email</th>
                        <th scope="col">Product Name</th>
                        <th scope="col">Created on</th>
                        <th scope="col">Space Occupied</th>
                        <th scope="col">Delete Data & Images</th>
                        <th scope="col">Delete Product</th>
                      </tr>
                    </thead>
                    <tbody>
                      {subFolders &&
                        subFolders.map((sub) => {
                          return (
                            <tr>
                              <td>{sub.user_name}</td>
                              <td>{sub.email}</td>
                              <td>{sub.product_name}</td>
                              <td>{sub.created_at}</td>
                              <td>
                                {Math.round(
                                  (sub.size / 1024 / 1024 + Number.EPSILON) *
                                    100
                                ) / 100}{" "}
                                MB
                              </td>
                              <td>
                                <Button
                                  className="btnsmall btn-success"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    //alert("Product will be deleted!!")
                                    let userConfirmation = confirm(
                                      "Are you sure you want to Delete Data & Images?"
                                    );

                                    if (userConfirmation) {
                                      // Code to execute if the user clicks "OK"
                                      deleteSpace(sub.product_id);
                                    } else {
                                      // Code to execute if the user clicks "Cancel"
                                      alert("User cancelled.");
                                    }
                                  }}
                                >
                                  Delete Data & Images
                                </Button>
                              </td>
                              <td>
                                <Button
                                  className="btnsmall btn-danger"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    //alert("Product will be deleted!!")
                                    let userConfirmation = confirm(
                                      "Are you sure you want to Delete Product?"
                                    );

                                    if (userConfirmation) {
                                      // Code to execute if the user clicks "OK"
                                      deleteProduct(sub.product_id);
                                    } else {
                                      // Code to execute if the user clicks "Cancel"
                                      alert("User cancelled.");
                                    }
                                  }}
                                >
                                  Delete Product
                                </Button>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </Col>
              </Row>
            )}
          </Modal.Body>
        </Modal>

        <Modal
          centered="true"
          dialogClassName="modal-90w"
          show={usersModal}
          onHide={() => {
            setusersModal(false);
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Manage Users</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <FieldGroup
                type="email"
                id="sub_user_email"
                label="Enter email of Registered User: "
                name="sub_user_email"
                placeholder="Enter email"
                value={subUserEmail}
                onChange={({ target: { name, value } }) => {
                  setsubUserEmail(value);
                  if (!setValidEmail(target.validity.valid)) {
                    alert(`${target.validationMessage}`);
                  }
                }}
              ></FieldGroup>
              {"   "}
              <Button
                style={{
                  backgroundColor: "green",
                  color: "white",
                  fontSize: "15px"
                }}
                onClick={() => {
                  if (subUserEmail != "") {
                    if (!validateEmail(subUserEmail)) {
                      alert("Enter valid email format");
                      return false;
                    }
                    if (
                      subUsers &&
                      subUsers.length > 0 &&
                      subUsers.some((subUser) => subUser.email === subUserEmail)
                    ) {
                      alert(
                        "User is already part of this Subscription!!\nEnter another email"
                      );
                    } else {
                      addSubUser(subUserEmail);
                    }
                  } else {
                    alert("Please enter a valid email");
                  }
                }}
              >
                Add User to Subscription
              </Button>
            </Form>

            {subUsers && subUsers.length > 0 && (
              <Row>
                <Col md={12}>
                  <table className="table table-bordered">
                    <caption
                      className="sub_folders"
                      style={{
                        color: "#3939d6",
                        fontWeight: "bolder",
                        fontSize: "20px"
                      }}
                    >
                      Subscription Users
                    </caption>
                    <thead>
                      <tr>
                        <th scope="col">User Name</th>
                        <th scope="col">Email</th>
                        <th scope="col">Role</th>
                        <th scope="col">Joined on</th>
                        <th scope="col">Delete User</th>
                      </tr>
                    </thead>
                    <tbody>
                      {subUsers &&
                        subUsers.map((sub) => {
                          return (
                            <tr>
                              <td>{sub.user_name}</td>
                              <td>{sub.email}</td>
                              <td>{sub.sub_role}</td>
                              <td>{sub.created_at}</td>
                              <td>
                                {" "}
                                {sub.sub_role === "ADMIN" ? (
                                  ""
                                ) : (
                                  <Button
                                    className="btnsmall btn-danger"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      e.preventDefault();
                                      if (sub.sub_role === "ADMIN") {
                                        alert(
                                          `Subscription 'ADMIN' user cannot be removed`
                                        );
                                        return false;
                                      }
                                      if (sub.product_count > 0) {
                                        alert(
                                          `User has ${sub.product_count} Product(s).\nPlease delete the products first before removing the User\nUser can remove the Product(s) or ADMIN user can remove the Product(s) under "Manage Space"`
                                        );
                                        return false;
                                      }
                                      //alert("Product will be deleted!!")
                                      let userConfirmation = confirm(
                                        "Are you sure you want to Delete User?"
                                      );

                                      if (userConfirmation) {
                                        // Code to execute if the user clicks "OK"
                                        deleteUser(sub.user_id);
                                      } else {
                                        // Code to execute if the user clicks "Cancel"
                                        alert("User not removed.");
                                      }
                                    }}
                                  >
                                    Remove User
                                  </Button>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </Col>
              </Row>
            )}
          </Modal.Body>
        </Modal>
      </Navbar.Collapse>
    </Navbar>
  ) : (
    <Navbar
      collapseOnSelect
      bg="dark"
      variant="dark"
      style={{ backgroundColor: "#000" }}
      position="top"
    >
      <div style={{ paddingTop: "7px" }}>
        <a href="/" className="navbar-left">
          <img height="40px" src={logo} />
        </a>

        <span>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span>

        <Navbar.Toggle
          style={{ backgroundColor: "#fff", height: "18px", paddingTop: "3px" }}
          aria-controls="responsive-navbar-nav"
        />
      </div>
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav>
          <NavItem eventKey={1} href="/static/Learn.html" target="blank">
            <span style={{ color: "white" }}>Learn</span>
          </NavItem>
          <NavItem
            divider="true"
            style={{ backgroundColor: "white", height: "1px" }}
          />
          <NavDropdown
            eventKey={3}
            backgroundColor="white"
            title={<span style={{ color: "white" }}>Audience</span>}
            id="1"
            onClick={toggleShow}
            open={show}
            onToggle={handleToggle}
          >
            <div style={{ display: show ? "block" : "none" }}>
              <MenuItem
                eventKey={3.1}
                href="/static/Schools.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Schools
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.2}
                href="/static/Colleges.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Colleges
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.3}
                href="/static/Students.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Students
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.4}
                href="/static/AlumniStudents.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Alumni Students
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.5}
                href="/static/Photographers.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Photographers
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.6}
                href="/static/Groups.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Groups
                </span>
              </MenuItem>
            </div>
          </NavDropdown>
          <NavItem
            divider="true"
            style={{ backgroundColor: "white", height: "0px" }}
          />
          <NavDropdown
            eventKey={3}
            title={<span style={{ color: "white" }}>Products</span>}
            id="2"
            onClick={toggleShow1}
            open={show1}
            onToggle={handleToggle}
          >
            <div style={{ display: show1 ? "block" : "none" }}>
              <MenuItem
                eventKey={3.1}
                href="/static/Composites.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Composites
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.2}
                href="/static/PictureBooklets.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Picture Booklets
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.3}
                href="/static/SportsBooklets.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Sports Booklets
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.4}
                href="/static/GraduationFolders.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Graduation Folders
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.5}
                href="/static/CustomYearBooks.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Custom Year Books
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.6}
                href="/static/ReportCardFolders.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Report Card Folders
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.7}
                href="/static/PortraitSheets.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Portrait Sheets
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.8}
                href="/static/PassportSheets.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Passport Sheets
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.9}
                href="/static/IDCardSheets.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  ID Card Sheets
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.1}
                href="/static/CustomCertificates.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Custom Certificates
                </span>
              </MenuItem>
              <MenuItem
                eventKey={3.11}
                href="/static/OtherProducts.html"
                target="blank"
                style={{ backgroundColor: "#000" }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    fontSize: "125%"
                  }}
                >
                  Other Products
                </span>
              </MenuItem>
            </div>
          </NavDropdown>
          <NavItem
            divider="true"
            style={{ backgroundColor: "white", height: "1px" }}
          />
          <NavItem eventKey={1} href="/presets">
            <span style={{ color: "white" }}>Presets</span>
          </NavItem>
          <NavItem
            divider="true"
            style={{ backgroundColor: "white", height: "1px" }}
          />
          {user_id != -1 ? (
            <Nav style={{ paddingLeft: "15px" }}>
              {window.subscription_status != "EXPIRED" ? (
                <NavDropdown
                  eventKey={3}
                  title={<span style={{ color: "white" }}>Dashboard</span>}
                  id="3"
                  onClick={toggleShow2}
                  open={show2}
                  onToggle={handleToggle}
                >
                  <div style={{ display: show2 ? "block" : "none" }}>
                    <MenuItem
                      eventKey={3.1}
                      href="/products"
                      style={{ backgroundColor: "#000000" }}
                    >
                      <span
                        style={{
                          color: "white",
                          fontWeight: "normal",
                          fontSize: "125%"
                        }}
                      >
                        My Products
                      </span>
                    </MenuItem>
                    {has_view_products ? (
                      <MenuItem
                        eventKey={3.2}
                        href="/orders"
                        target="blank"
                        style={{ backgroundColor: "#000000" }}
                      >
                        <span
                          style={{
                            color: "white",
                            fontWeight: "normal",
                            fontSize: "125%"
                          }}
                        >
                          View/Pay Products
                        </span>
                      </MenuItem>
                    ) : (
                      <MenuItem
                        eventKey={3.2}
                        href="/products/add"
                        target="blank"
                        style={{ backgroundColor: "#000000" }}
                      >
                        <span
                          style={{
                            color: "white",
                            fontWeight: "normal",
                            fontSize: "125%"
                          }}
                        >
                          Add View/Pay Products
                        </span>
                      </MenuItem>
                    )}
                  </div>
                </NavDropdown>
              ) : (
                ""
              )}

              <NavItem
                divider="true"
                style={{ backgroundColor: "white", height: "1px" }}
              />

              {sub_id < 1 ? (
                <NavItem eventKey={1} href="/orders/cart">
                  <span style={{ color: "white" }}>Cart</span>
                </NavItem>
              ) : (
                ""
              )}

              <NavItem
                divider="true"
                style={{ backgroundColor: "white", height: "1px" }}
              />
              <NavDropdown
                eventKey={2}
                id="4"
                title={<img height="20px" src={profile} />}
                onClick={toggleShow3}
                open={show3}
                onToggle={handleToggle}
              >
                <div style={{ display: show3 ? "block" : "none" }}>
                  <li className="dropdown-header">
                    <span
                      style={{
                        textAlign: "center",
                        color: "gray",
                        fontWeight: "normal",
                        fontSize: "125%"
                      }}
                    >
                      Logged in as:{" "}
                    </span>
                    <br></br>
                    <span
                      style={{
                        textAlign: "center",
                        color: "white",
                        fontWeight: "bold",
                        fontSize: "125%"
                      }}
                    >
                      {user_name}
                    </span>
                  </li>
                  <MenuItem
                    eventKey={3.1}
                    href="/users/sign_out"
                    data-method="delete"
                    style={{ backgroundColor: "#ff0000" }}
                  >
                    <span
                      style={{
                        color: "white",
                        fontWeight: "normal",
                        fontSize: "125%"
                      }}
                    >
                      Log out
                    </span>
                  </MenuItem>
                </div>
              </NavDropdown>
            </Nav>
          ) : (
            <Nav style={{ paddingLeft: "15px" }}>
              <NavItem eventKey={1} href="/users/sign_in">
                <span style={{ color: "white" }}>Login</span>
              </NavItem>
            </Nav>
          )}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default ProductMynavbar;
